import React, { useState, useRef, useEffect, useMemo } from "react";
import {
  GridComponent,
  ColumnsDirective,
  ColumnDirective,
  Page,
  Sort,
  Filter,
  Search,
  Inject,
  ColumnMenu,
  Group,
  Toolbar,
  Edit,
  Selection,
} from "@syncfusion/ej2-react-grids";
import { db } from "../../../firebase";
import {
  collection,
  query,
  where,
  getDocs,
  doc,
  getDoc,
  setDoc,
  serverTimestamp,
  updateDoc,
  addDoc,
  getFirestore,
} from "firebase/firestore";
import { DialogComponent } from "@syncfusion/ej2-react-popups";
import { DropDownListComponent } from "@syncfusion/ej2-react-dropdowns";
import { onAuthStateChanged, getAuth } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import { useGeneralContext } from "../../../context/GeneralContext";
import { L10n } from "@syncfusion/ej2-base";
import RecoveryPlanIcon from "../../../icons/CaseManagement/recovery plan.svg";
import ReassignIcon from "../../../icons/CaseManagement/reassign.svg";
import AssignIcon from "../../../icons/CaseManagement/assign.svg";
import AccessAccountIcon from "../../../icons/CaseManagement/access account.svg";
import StatusOpenIcon from "../../../icons/CaseManagement/status-open.svg";
import StatusClosedIcon from "../../../icons/CaseManagement/status-closed.svg";
import AddToCaseManagement from "../../../icons/CaseManagement/add-to-case.svg";
import AdvanceSearch from "../../../icons/CaseManagement/manage_search.svg";
import { v4 as uuidv4 } from "uuid";
import { TextBoxComponent } from "@syncfusion/ej2-react-inputs";
import { DatePickerComponent } from "@syncfusion/ej2-react-calendars";
import mailer from "../../../service/api/mailer";
import { Sidebar } from "@syncfusion/ej2-react-navigations";
import { MultiSelectComponent } from "@syncfusion/ej2-react-dropdowns";
import {
  useReactTable,
  getCoreRowModel,
  getGroupedRowModel,
  getExpandedRowModel,
  flexRender,
  getSortedRowModel,
} from "@tanstack/react-table";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import {
  FaFolderOpen,
  FaPauseCircle,
  FaCheck,
  FaPlus,
  FaChevronDown,
  FaChevronUp,
} from "react-icons/fa";
import CaseManagementDashboard from "../../center-pov/CaseManagement/CaseManagementDashboard";

L10n.load({
  "en-US": {
    grid: {
      GroupCaption: "${field}: ${key} - ${count} cases",
      UnassignedCaption: "Unassigned",
      UnspecifiedCaption: "Unspecified",
      EmptyDataSourceError: "No records to display",
      GroupDropArea: "Drag a column header here to group by that column",
    },
  },
});

const filterSettings = {
  type: "CheckBox",
};

const sortSettings = {
  allowSorting: true,
};

const columnMenuItems = ["SortAscending", "SortDescending", "Filter"];

const pageSettings = { pageSize: 10 };

const editSettings = {
  allowEditing: true,
  allowAdding: true,
  showDeleteConfirmDialog: true,
  allowDeleting: true,
  allowEditOnDblClick: false,
  mode: "Dialog",
  dialog: { cssClass: "custom-dialog" },
};

const sortOptions = [
  "By Date (Ascending Order)",
  "By Date (Descending Order)",
  "By Alphabetical (Ascending Order)",
  "By Alphabetical (Descending Order)",
];

const damageMapping = {
  "Minor Damage": ["No Damage", "Slight Damage"],
  "Regular Damage": ["Limited Damage"],
  "Major Damage": ["Severe Damage"],
  "Badly Damage": ["Total Destruction"],
};

const damageOptions = [
  "No Damage",
  "Slight Damage",
  "Limited Damage",
  "Severe Damage",
  "Total Destruction",
];

const CaseManagementPartner = () => {
  const [selectedDisasters, setSelectedDisasters] = useState([]);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [disasterOptions, setDisasterOptions] = useState([
    { id: "All", name: "All Disasters" },
  ]);
  const [activeDisasters, setActiveDisasters] = useState([]);
  const dropdownRef = useRef(null);
  const [assignDialogOpen, setAssignDialogOpen] = useState(false);
  const [selectedCase, setSelectedCase] = useState(null);
  const [employees, setEmployees] = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [selectedSupervisor, setSelectedSupervisor] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState("Open");
  const [gridData, setGridData] = useState([]);
  const [userData, setUserData] = useState(null);
  const [applyToFutureGroup, setApplyToFutureGroup] = useState(false);
  const [partnerDoc, setPartnerDoc] = useState(null);

  const [selectedRecords, setSelectedRecords] = useState([]);
  const [disasterStats, setDisasterStats] = useState([]);
  const [assignmentType, setAssignmentType] = useState("Case Manager");

  const { employeeId, setEmployeeIdfunc } = useGeneralContext();
  const [employeeRole, setEmployeeRole] = useState(null);
  const [partners, setPartners] = useState([]);
  const [dropdownValue, setDropdownValue] = useState(null);
  const gridRef = useRef(null);
  const navigate = useNavigate();
  const [userId, setUserId] = useState(null);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  const toggleDropdown = () => setDropdownOpen(!dropdownOpen);
  const [showHomeowner, setShowHomeowner] = useState(true);
  const [showDamage, setShowDamage] = useState(true);
  const [showStatus, setShowStatus] = useState(true);
  const [activePanel, setActivePanel] = useState("filter");
  const [openPanel, setOpenPanel] = useState(false);
  const [selectedDisaster, setSelectedDisaster] = useState(null);
  const [tempSelectedSort, setTempSelectedSort] = useState("");
  const [tempSelectedDisasters, setTempSelectedDisasters] = useState(
    selectedDisasters || ""
  );
  const selectedUserId = sessionStorage.getItem("userId");
  const employeeDetails = JSON.parse(sessionStorage.getItem("employeeDetails"));

  const [tempSelectedStatus, setTempSelectedStatus] = useState({
    Open: false,
    Closed: false,
    Unassigned: false,
  });
  // Add this useEffect for authentication
  useEffect(() => {
    const auth = getAuth();

    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      if (currentUser && selectedUserId) {
        setUserId(selectedUserId);
      } else {
        console.log("No user is logged in");
      }
    });

    return () => unsubscribe();
  }, []);

  // Modify your existing fetchDisasters useEffect
  useEffect(() => {
    const fetchDisasters = async () => {
      try {
        // First get the current user's center
        const auth = getAuth();
        const userDoc = await getDoc(doc(db, "centers", userData?.center_id));
        const centerCounty = userDoc.data()?.county;

        if (!centerCounty) {
          console.warn("Center county not found");
          return;
        }

        const disastersQuery = query(collection(db, "declared-disaster"));
        const querySnapshot = await getDocs(disastersQuery);
        const fetchedDisasters = querySnapshot.docs
          .map((doc) => ({
            id: doc.id,
            name: doc.data().disaster_name,
            status: doc.data().disaster_status,
            disaster_type: doc.data().disaster_type,
            county: doc.data().disaster_county,
            state: doc.data().disaster_state,
            affected_counties: doc.data().affected_counties || [],
          }))
          .filter((disaster) =>
            disaster.affected_counties.includes(centerCounty)
          );

        // Sort disasters by status: active first, then inactive, then closed
        const activeDisasters = fetchedDisasters.filter(
          (disaster) => disaster.status === "active"
        );
        const inactiveDisasters = fetchedDisasters.filter(
          (disaster) => disaster.status === "inactive"
        );
        const closedDisasters = fetchedDisasters.filter(
          (disaster) => disaster.status === "closed"
        );

        const sortedDisasters = [
          ...activeDisasters,
          ...inactiveDisasters,
          ...closedDisasters,
        ];

        setActiveDisasters(activeDisasters.map((disaster) => disaster.id));
        setDisasterOptions(sortedDisasters);
        if (activeDisasters.length > 0) {
          setSelectedDisasters([activeDisasters[0].id]);
        }

        // Fetch statistics for the disasters
        await fetchDisasterStats(sortedDisasters);
      } catch (error) {
        console.error("Error fetching disasters:", error);
      }
    };

    fetchDisasters();
  }, [userData?.center_id]);

  const handleDialogClose = () => {
    setAssignDialogOpen(false);
    setSelectedEmployee(null);
    setSelectedCompany(null);
    setAssignmentType("Case Manager");
    setApplyToFutureGroup(false);
    setDropdownValue(null); // Reset dropdown value
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleClose = () => {
    navigate("/home");
  };

  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [activeView, setActiveView] = useState("dashboard");

  // Add these components for the sidebar views
  const CaseManagerView = () => (
    <div className="px-4">
      <div className="space-y-3">
        {employees
          .filter((employee) => !employee.is_admin)
          .map((employee) => {
            const assignedCaseCount = caseManagerCaseCounts[employee.id] || 0;
            return (
              <div
                key={employee.id}
                className="rounded-lg bg-white p-4 shadow-lg"
              >
                <h3 className="text-lg font-medium">{employee.fullName}</h3>
                <div className="text-gray-600 mt-2 space-y-2 text-sm">
                  <div className="flex items-center gap-2">
                    <svg
                      width="24"
                      height="15"
                      viewBox="0 0 24 15"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M5.10345 0.554688C4.48852 0.554688 3.99349 1.12028 3.99349 1.82277V4.00112H0.868804C0.387484 4.00112 0 4.38859 0 4.8699V13.5747C0 14.056 0.387484 14.4434 0.868804 14.4434H13.6611C14.1424 14.4434 14.5299 14.056 14.5299 13.5747V13.4365C12.343 13.1823 10.6924 11.3316 10.6889 9.12989C10.6923 6.92992 12.3403 5.08 14.5253 4.82356C14.5009 4.36442 14.1266 4.00112 13.6611 4.00112H10.6625V1.82277C10.6625 1.12028 10.1675 0.554688 9.55255 0.554688H5.10345ZM5.23922 2.02399H9.36239V4.00112H5.23922V2.02399ZM22.8082 3.57097C22.7683 3.56908 22.7283 3.56908 22.6884 3.57104C22.3692 3.58649 22.0561 3.72417 21.8233 3.98065L16.7337 9.58843L14.221 7.03325C13.9982 6.80673 13.6905 6.69815 13.3875 6.71171C13.1519 6.72219 12.9191 6.80674 12.7313 6.96683C12.3021 7.33277 12.2752 7.95152 12.6712 8.35422L16.2691 12.013C16.6454 12.3956 17.2634 12.4408 17.6924 12.1306C17.824 12.0635 17.9464 11.9729 18.0519 11.8567L23.6743 5.66182C24.1398 5.14888 24.1019 4.36109 23.5891 3.89539C23.3648 3.69166 23.0878 3.58429 22.8082 3.57097Z"
                        fill="#1C82D8"
                      />
                    </svg>

                    <p className="text-[#525252]">Assigned Cases: </p>
                    {assignedCaseCount}
                  </div>

                  <div className="flex items-center gap-2">
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M3 10.0012C3 11.5512 3.4375 12.9387 4.3125 14.1637C5.1875 15.3887 6.34167 16.2262 7.775 16.6762C8.075 16.7762 8.32083 16.9637 8.5125 17.2387C8.70417 17.5137 8.8 17.8179 8.8 18.1512C8.8 18.6345 8.59583 19.0179 8.1875 19.3012C7.77917 19.5845 7.33333 19.6429 6.85 19.4762C4.78333 18.7929 3.125 17.5845 1.875 15.8512C0.625 14.1179 0 12.1679 0 10.0012C0 7.83452 0.625 5.88452 1.875 4.15119C3.125 2.41785 4.78333 1.20952 6.85 0.526186C7.33333 0.35952 7.77917 0.417853 8.1875 0.701186C8.59583 0.98452 8.8 1.36785 8.8 1.85119C8.8 2.18452 8.70417 2.48869 8.5125 2.76369C8.32083 3.03869 8.075 3.22619 7.775 3.32619C6.34167 3.77619 5.1875 4.61369 4.3125 5.83869C3.4375 7.06369 3 8.45119 3 10.0012ZM17.05 17.0512C16.5167 17.6012 15.9125 18.0804 15.2375 18.4887C14.5625 18.897 13.8583 19.2262 13.125 19.4762C12.6417 19.6429 12.1958 19.5845 11.7875 19.3012C11.3792 19.0179 11.175 18.6345 11.175 18.1512C11.175 17.8179 11.2708 17.5137 11.4625 17.2387C11.6542 16.9637 11.9 16.7762 12.2 16.6762C12.7167 16.5095 13.2125 16.2804 13.6875 15.9887C14.1625 15.697 14.5917 15.3595 14.975 14.9762C15.3583 14.5762 15.6917 14.147 15.975 13.6887C16.2583 13.2304 16.4917 12.7345 16.675 12.2012C16.775 11.9012 16.9625 11.6554 17.2375 11.4637C17.5125 11.272 17.8167 11.1762 18.15 11.1762C18.6333 11.1762 19.0167 11.3804 19.3 11.7887C19.5833 12.197 19.6417 12.6429 19.475 13.1262C19.225 13.8595 18.8958 14.5595 18.4875 15.2262C18.0792 15.8929 17.6 16.5012 17.05 17.0512ZM17.05 2.95119C17.6 3.50119 18.0792 4.10952 18.4875 4.77619C18.8958 5.44285 19.225 6.14285 19.475 6.87619C19.6417 7.35952 19.5833 7.80535 19.3 8.21369C19.0167 8.62202 18.6333 8.82619 18.15 8.82619C17.8167 8.82619 17.5125 8.73035 17.2375 8.53869C16.9625 8.34702 16.775 8.10119 16.675 7.80119C16.4917 7.26785 16.2583 6.77202 15.975 6.31369C15.6917 5.85535 15.3583 5.42619 14.975 5.02619C14.5917 4.64285 14.1625 4.30535 13.6875 4.01369C13.2125 3.72202 12.7167 3.49285 12.2 3.32619C11.9 3.22619 11.6542 3.03869 11.4625 2.76369C11.2708 2.48869 11.175 2.18452 11.175 1.85119C11.175 1.36785 11.3792 0.98452 11.7875 0.701186C12.1958 0.417853 12.6417 0.35952 13.125 0.526186C13.8583 0.776186 14.5625 1.10535 15.2375 1.51369C15.9125 1.92202 16.5167 2.40119 17.05 2.95119Z"
                        fill="#1C82D8"
                      />
                    </svg>

                    <p className="text-[#525252]">Staus: </p>
                    <span
                      className={`rounded-full px-2 py-1 text-xs ${
                        assignedCaseCount > 0
                          ? "bg-green-50 text-green-700"
                          : "bg-gray-50 text-gray-700"
                      }`}
                    >
                      {assignedCaseCount > 0 ? "Active" : "No Cases"}
                    </span>
                  </div>
                </div>
              </div>
            );
          })}
      </div>
    </div>
  );

  const CitizensView = () => (
    <div className="px-4">
      <div className="space-y-3">
        {gridData.map((citizen) => (
          <div key={citizen.id} className="rounded-lg bg-white p-4 shadow-lg">
            <h3 className="text-lg font-medium">{citizen.name}</h3>
            <div className="text-gray-600 mt-2 space-y-2 text-sm">
              <div className="flex items-center gap-2">
                <svg
                  width="18"
                  height="16"
                  viewBox="0 0 18 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M6.00044 12L5.17544 15.275C5.12544 15.4917 5.0171 15.6667 4.85044 15.8C4.68377 15.9333 4.48377 16 4.25044 16C3.93377 16 3.67544 15.875 3.47544 15.625C3.27544 15.375 3.2171 15.1 3.30044 14.8L4.00044 12H1.27544C0.942103 12 0.675437 11.8708 0.475437 11.6125C0.275437 11.3542 0.217103 11.0667 0.300437 10.75C0.350437 10.5167 0.467103 10.3333 0.650437 10.2C0.83377 10.0667 1.0421 10 1.27544 10H4.50044L5.50044 6H2.77544C2.4421 6 2.17544 5.87083 1.97544 5.6125C1.77544 5.35417 1.7171 5.06667 1.80044 4.75C1.85044 4.51667 1.9671 4.33333 2.15044 4.2C2.33377 4.06667 2.5421 4 2.77544 4H6.00044L6.82544 0.725C6.87544 0.508333 6.98377 0.333333 7.15044 0.2C7.3171 0.0666667 7.5171 0 7.75044 0C8.0671 0 8.32544 0.125 8.52544 0.375C8.72544 0.625 8.78377 0.9 8.70044 1.2L8.00044 4H12.0004L12.8254 0.725C12.8754 0.508333 12.9838 0.333333 13.1504 0.2C13.3171 0.0666667 13.5171 0 13.7504 0C14.0671 0 14.3254 0.125 14.5254 0.375C14.7254 0.625 14.7838 0.9 14.7004 1.2L14.0004 4H16.7254C17.0588 4 17.3254 4.12917 17.5254 4.3875C17.7254 4.64583 17.7838 4.93333 17.7004 5.25C17.6504 5.48333 17.5338 5.66667 17.3504 5.8C17.1671 5.93333 16.9588 6 16.7254 6H13.5004L12.5004 10H15.2254C15.5588 10 15.8254 10.1292 16.0254 10.3875C16.2254 10.6458 16.2838 10.9333 16.2004 11.25C16.1504 11.4833 16.0338 11.6667 15.8504 11.8C15.6671 11.9333 15.4588 12 15.2254 12H12.0004L11.1754 15.275C11.1254 15.4917 11.0171 15.6667 10.8504 15.8C10.6838 15.9333 10.4838 16 10.2504 16C9.93377 16 9.67544 15.875 9.47544 15.625C9.27544 15.375 9.2171 15.1 9.30044 14.8L10.0004 12H6.00044ZM6.50044 10H10.5004L11.5004 6H7.50044L6.50044 10Z"
                    fill="#1C82D8"
                  />
                </svg>
                <p className="text-[#525252]">Case #: </p>
                {citizen.case_number}
              </div>
              <div className="flex items-center gap-2">
                <svg
                  width="16"
                  height="20"
                  viewBox="0 0 16 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M8 19.325C7.76667 19.325 7.53333 19.2833 7.3 19.2C7.06667 19.1167 6.85833 18.9917 6.675 18.825C5.59167 17.825 4.63333 16.85 3.8 15.9C2.96667 14.95 2.27083 14.0292 1.7125 13.1375C1.15417 12.2458 0.729167 11.3875 0.4375 10.5625C0.145833 9.7375 0 8.95 0 8.2C0 5.7 0.804167 3.70833 2.4125 2.225C4.02083 0.741667 5.88333 0 8 0C10.1167 0 11.9792 0.741667 13.5875 2.225C15.1958 3.70833 16 5.7 16 8.2C16 8.95 15.8542 9.7375 15.5625 10.5625C15.2708 11.3875 14.8458 12.2458 14.2875 13.1375C13.7292 14.0292 13.0333 14.95 12.2 15.9C11.3667 16.85 10.4083 17.825 9.325 18.825C9.14167 18.9917 8.93333 19.1167 8.7 19.2C8.46667 19.2833 8.23333 19.325 8 19.325ZM8 10C8.55 10 9.02083 9.80417 9.4125 9.4125C9.80417 9.02083 10 8.55 10 8C10 7.45 9.80417 6.97917 9.4125 6.5875C9.02083 6.19583 8.55 6 8 6C7.45 6 6.97917 6.19583 6.5875 6.5875C6.19583 6.97917 6 7.45 6 8C6 8.55 6.19583 9.02083 6.5875 9.4125C6.97917 9.80417 7.45 10 8 10Z"
                    fill="#1C82D8"
                  />
                </svg>

                <p className="text-[#525252]">County: </p>
                {citizen.county}
              </div>
              <div className="flex items-center gap-2">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M3 10.0012C3 11.5512 3.4375 12.9387 4.3125 14.1637C5.1875 15.3887 6.34167 16.2262 7.775 16.6762C8.075 16.7762 8.32083 16.9637 8.5125 17.2387C8.70417 17.5137 8.8 17.8179 8.8 18.1512C8.8 18.6345 8.59583 19.0179 8.1875 19.3012C7.77917 19.5845 7.33333 19.6429 6.85 19.4762C4.78333 18.7929 3.125 17.5845 1.875 15.8512C0.625 14.1179 0 12.1679 0 10.0012C0 7.83452 0.625 5.88452 1.875 4.15119C3.125 2.41785 4.78333 1.20952 6.85 0.526186C7.33333 0.35952 7.77917 0.417853 8.1875 0.701186C8.59583 0.98452 8.8 1.36785 8.8 1.85119C8.8 2.18452 8.70417 2.48869 8.5125 2.76369C8.32083 3.03869 8.075 3.22619 7.775 3.32619C6.34167 3.77619 5.1875 4.61369 4.3125 5.83869C3.4375 7.06369 3 8.45119 3 10.0012ZM17.05 17.0512C16.5167 17.6012 15.9125 18.0804 15.2375 18.4887C14.5625 18.897 13.8583 19.2262 13.125 19.4762C12.6417 19.6429 12.1958 19.5845 11.7875 19.3012C11.3792 19.0179 11.175 18.6345 11.175 18.1512C11.175 17.8179 11.2708 17.5137 11.4625 17.2387C11.6542 16.9637 11.9 16.7762 12.2 16.6762C12.7167 16.5095 13.2125 16.2804 13.6875 15.9887C14.1625 15.697 14.5917 15.3595 14.975 14.9762C15.3583 14.5762 15.6917 14.147 15.975 13.6887C16.2583 13.2304 16.4917 12.7345 16.675 12.2012C16.775 11.9012 16.9625 11.6554 17.2375 11.4637C17.5125 11.272 17.8167 11.1762 18.15 11.1762C18.6333 11.1762 19.0167 11.3804 19.3 11.7887C19.5833 12.197 19.6417 12.6429 19.475 13.1262C19.225 13.8595 18.8958 14.5595 18.4875 15.2262C18.0792 15.8929 17.6 16.5012 17.05 17.0512ZM17.05 2.95119C17.6 3.50119 18.0792 4.10952 18.4875 4.77619C18.8958 5.44285 19.225 6.14285 19.475 6.87619C19.6417 7.35952 19.5833 7.80535 19.3 8.21369C19.0167 8.62202 18.6333 8.82619 18.15 8.82619C17.8167 8.82619 17.5125 8.73035 17.2375 8.53869C16.9625 8.34702 16.775 8.10119 16.675 7.80119C16.4917 7.26785 16.2583 6.77202 15.975 6.31369C15.6917 5.85535 15.3583 5.42619 14.975 5.02619C14.5917 4.64285 14.1625 4.30535 13.6875 4.01369C13.2125 3.72202 12.7167 3.49285 12.2 3.32619C11.9 3.22619 11.6542 3.03869 11.4625 2.76369C11.2708 2.48869 11.175 2.18452 11.175 1.85119C11.175 1.36785 11.3792 0.98452 11.7875 0.701186C12.1958 0.417853 12.6417 0.35952 13.125 0.526186C13.8583 0.776186 14.5625 1.10535 15.2375 1.51369C15.9125 1.92202 16.5167 2.40119 17.05 2.95119Z"
                    fill="#1C82D8"
                  />
                </svg>

                <p className="text-[#525252]">Staus: </p>
                <span
                  className={`ml-2 rounded-full px-2 py-1 text-xs ${
                    citizen.status === "Open"
                      ? "bg-green-50 text-green-700"
                      : citizen.status === "Unassigned"
                      ? "bg-yellow-50 text-yellow-700"
                      : "bg-gray-50 text-gray-700"
                  }`}
                >
                  {citizen.status}
                </span>
              </div>
              <div className="flex items-center gap-2">
                <svg
                  width="20"
                  height="16"
                  viewBox="0 0 20 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M8 8C6.9 8 5.95833 7.60833 5.175 6.825C4.39167 6.04167 4 5.1 4 4C4 2.9 4.39167 1.95833 5.175 1.175C5.95833 0.391667 6.9 0 8 0C9.1 0 10.0417 0.391667 10.825 1.175C11.6083 1.95833 12 2.9 12 4C12 5.1 11.6083 6.04167 10.825 6.825C10.0417 7.60833 9.1 8 8 8ZM2 16C1.45 16 0.979167 15.8042 0.5875 15.4125C0.195833 15.0208 0 14.55 0 14V13.2C0 12.65 0.141667 12.1333 0.425 11.65C0.708333 11.1667 1.1 10.8 1.6 10.55C2.45 10.1167 3.40833 9.75 4.475 9.45C5.54167 9.15 6.71667 9 8 9H8.6625C8.87083 9 9.08333 9.01667 9.3 9.05C9.63333 9.08333 9.85 9.25833 9.95 9.575C10.05 9.89167 9.98333 10.1667 9.75 10.4L9.325 10.825C8.80833 11.3417 8.51667 11.95 8.45 12.65C8.38333 13.35 8.54167 13.9917 8.925 14.575C9.125 14.8917 9.15417 15.2083 9.0125 15.525C8.87083 15.8417 8.63333 16 8.3 16H2ZM13.55 13.6L17.9 9.25C18.0833 9.06667 18.3167 8.975 18.6 8.975C18.8833 8.975 19.1167 9.06667 19.3 9.25C19.4833 9.43333 19.575 9.66667 19.575 9.95C19.575 10.2333 19.4833 10.4667 19.3 10.65L14.25 15.7C14.05 15.9 13.8167 16 13.55 16C13.2833 16 13.05 15.9 12.85 15.7L10.8 13.65C10.6167 13.4667 10.525 13.2333 10.525 12.95C10.525 12.6667 10.6167 12.4333 10.8 12.25C10.9833 12.0667 11.2167 11.975 11.5 11.975C11.7833 11.975 12.0167 12.0667 12.2 12.25L13.55 13.6Z"
                    fill="#1C82D8"
                  />
                </svg>

                <p className="text-[#525252]">Assigned To: </p>
                {citizen.assigned_to_case_manager || "Unassigned"}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );

  const EmployeeView = () => {
    return (
      <div className="px-4">
        <div className="space-y-3">
          {employees.map((employee) => (
            <div
              key={employee.id}
              className="rounded-lg bg-white p-4 shadow-lg"
            >
              <h3 className="text-lg font-medium">{employee.fullName}</h3>
              <div className="text-gray-600 mt-2 space-y-2 text-sm">
                <div className="flex items-center gap-2">
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M10 10C8.9 10 7.95833 9.60833 7.175 8.825C6.39167 8.04167 6 7.1 6 6C6 4.9 6.39167 3.95833 7.175 3.175C7.95833 2.39167 8.9 2 10 2C11.1 2 12.0417 2.39167 12.825 3.175C13.6083 3.95833 14 4.9 14 6C14 7.1 13.6083 8.04167 12.825 8.825C12.0417 9.60833 11.1 10 10 10ZM3 18C2.45 18 1.97917 17.8042 1.5875 17.4125C1.19583 17.0208 1 16.55 1 16V15.2C1 14.6333 1.14583 14.1125 1.4375 13.6375C1.72917 13.1625 2.11667 12.8 2.6 12.55C3.45 12.1167 4.40833 11.7708 5.475 11.5125C6.54167 11.2542 7.71667 11.125 9 11.125C10.2833 11.125 11.4583 11.2542 12.525 11.5125C13.5917 11.7708 14.55 12.1167 15.4 12.55C15.8833 12.8 16.2708 13.1625 16.5625 13.6375C16.8542 14.1125 17 14.6333 17 15.2V16C17 16.55 16.8042 17.0208 16.4125 17.4125C16.0208 17.8042 15.55 18 15 18H3Z"
                      fill="#1C82D8"
                    />
                  </svg>
                  <p className="text-[#525252]">Role: </p>
                  {employee.role || "Not Specified"}
                </div>

                <div className="flex items-center gap-2">
                  <svg
                    width="20"
                    height="16"
                    viewBox="0 0 20 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M17 0H3C2.20435 0 1.44129 0.316071 0.87868 0.87868C0.316071 1.44129 0 2.20435 0 3V13C0 13.7956 0.316071 14.5587 0.87868 15.1213C1.44129 15.6839 2.20435 16 3 16H17C17.7956 16 18.5587 15.6839 19.1213 15.1213C19.6839 14.5587 20 13.7956 20 13V3C20 2.20435 19.6839 1.44129 19.1213 0.87868C18.5587 0.316071 17.7956 0 17 0ZM17 2L10.5 6.47C10.348 6.55777 10.1755 6.60397 10 6.60397C9.82446 6.60397 9.65202 6.55777 9.5 6.47L3 2H17Z"
                      fill="#1C82D8"
                    />
                  </svg>
                  <p className="text-[#525252]">Email: </p>
                  {employee.email || "Not Provided"}
                </div>

                <div className="flex items-center gap-2">
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M17.9066 12.6307C16.7184 12.6307 15.5501 12.4133 14.4503 11.9784C13.9169 11.7811 13.2851 11.9187 12.9128 12.2911L10.7092 13.9643C8.16938 12.6307 6.36938 10.8307 5.03578 8.29087L6.67542 6.12337C7.08459 5.71421 7.20866 5.11254 7.01938 4.54921C6.58322 3.44921 6.36578 2.28087 6.36578 1.09254C6.36578 0.489209 5.87657 0 5.27324 0H1.09255C0.489217 0 0 0.489209 0 1.09254C0 11.7414 8.25866 20 18.9075 20C19.5109 20 20.0001 19.5108 20.0001 18.9075V14.7268C20 14.1234 19.5108 13.6342 18.9075 13.6342H17.9066V12.6307Z"
                      fill="#1C82D8"
                    />
                  </svg>
                  <p className="text-[#525252]">Phone: </p>
                  {employee.phone || employee.mobile_number || "Not Provided"}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  };

  const DisasterView = () => (
    <div className="px-4">
      <div className="space-y-3">
        {disasterStats.map((disaster) => (
          <div
            key={disaster.disaster_id}
            className="rounded-lg bg-white p-4 shadow-lg"
          >
            <h3 className="text-lg font-medium">{disaster.disaster_name}</h3>
            <div className="text-gray-600 mt-2 space-y-2 text-sm">
              <div className="flex items-center gap-2 font-medium">
                <svg
                  width="20"
                  height="19"
                  viewBox="0 0 20 19"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M2 19C1.45 19 0.979167 18.8042 0.5875 18.4125C0.195833 18.0208 0 17.55 0 17V6C0 5.45 0.195833 4.97917 0.5875 4.5875C0.979167 4.19583 1.45 4 2 4H6V2C6 1.45 6.19583 0.979167 6.5875 0.5875C6.97917 0.195833 7.45 0 8 0H12C12.55 0 13.0208 0.195833 13.4125 0.5875C13.8042 0.979167 14 1.45 14 2V4H18C18.55 4 19.0208 4.19583 19.4125 4.5875C19.8042 4.97917 20 5.45 20 6V17C20 17.55 19.8042 18.0208 19.4125 18.4125C19.0208 18.8042 18.55 19 18 19H2ZM8 4H12V2H8V4Z"
                    fill="#1C82D8"
                  />
                </svg>
                <p>Case Details:</p>
              </div>
              <div className="flex items-center gap-2">
                <p className="text-[#525252]">Total Cases: </p>
                {disaster.total_cases}
              </div>
              <div className="flex items-center gap-2">
                <p className="text-[#525252]">Open Cases: </p>
                {disaster.open_cases}
              </div>
              <div className="flex items-center gap-2">
                <p className="text-[#525252]">Unassigned: </p>
                {disaster.unassigned_cases}
              </div>
              <div className="mt-3">
                <div className="flex items-center gap-2 font-medium">
                  <svg
                    width="16"
                    height="20"
                    viewBox="0 0 16 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8 19.325C7.76667 19.325 7.53333 19.2833 7.3 19.2C7.06667 19.1167 6.85833 18.9917 6.675 18.825C5.59167 17.825 4.63333 16.85 3.8 15.9C2.96667 14.95 2.27083 14.0292 1.7125 13.1375C1.15417 12.2458 0.729167 11.3875 0.4375 10.5625C0.145833 9.7375 0 8.95 0 8.2C0 5.7 0.804167 3.70833 2.4125 2.225C4.02083 0.741667 5.88333 0 8 0C10.1167 0 11.9792 0.741667 13.5875 2.225C15.1958 3.70833 16 5.7 16 8.2C16 8.95 15.8542 9.7375 15.5625 10.5625C15.2708 11.3875 14.8458 12.2458 14.2875 13.1375C13.7292 14.0292 13.0333 14.95 12.2 15.9C11.3667 16.85 10.4083 17.825 9.325 18.825C9.14167 18.9917 8.93333 19.1167 8.7 19.2C8.46667 19.2833 8.23333 19.325 8 19.325ZM8 10C8.55 10 9.02083 9.80417 9.4125 9.4125C9.80417 9.02083 10 8.55 10 8C10 7.45 9.80417 6.97917 9.4125 6.5875C9.02083 6.19583 8.55 6 8 6C7.45 6 6.97917 6.19583 6.5875 6.5875C6.19583 6.97917 6 7.45 6 8C6 8.55 6.19583 9.02083 6.5875 9.4125C6.97917 9.80417 7.45 10 8 10Z"
                      fill="#1C82D8"
                    />
                  </svg>

                  <p>Counties Affected:</p>
                </div>
                <div className="mt-1 flex flex-wrap gap-2">
                  {disaster.counties.map((county) => (
                    <span
                      key={county.county}
                      className="bg-gray-50 rounded-full py-1 text-xs"
                    >
                      {county.county} ({county.total_cases})
                    </span>
                  ))}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );

  const [caseManagerCaseCounts, setCaseManagerCaseCounts] = useState({});

  // Add this useEffect to fetch case counts
  useEffect(() => {
    const fetchCaseManagerCaseCounts = async () => {
      if (!userData?.partner_id || !employees.length) return;

      try {
        const caseManagementRef = collection(db, "case_management");
        const caseCounts = {};

        // Fetch cases for all employees in parallel
        await Promise.all(
          employees.map(async (employee) => {
            const caseQuery = query(
              caseManagementRef,
              where("assigned_to_case_manager_uid", "==", employee.id)
            );

            const querySnapshot = await getDocs(caseQuery);
            caseCounts[employee.id] = querySnapshot.size;
          })
        );

        setCaseManagerCaseCounts(caseCounts);
      } catch (error) {
        console.error("Error fetching caseManager case counts:", error);
      }
    };

    fetchCaseManagerCaseCounts();
  }, [userData?.partner_id, employees]);

  const renderSidebarContent = () => {
    switch (activeView) {
      case "citizens":
        return <CitizensView />;
      case "caseManager":
        return <CaseManagerView />;
      case "disasters":
        return <DisasterView />;
      case "employees":
        return <EmployeeView />;
      default:
        return null;
    }
  };

  // Add this function to fetch employees
  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const auth = getAuth();
        if (!auth.currentUser) {
          console.log("No user logged in");
          return;
        }

        // First get the user document
        const userDoc = await getDoc(doc(db, "users", selectedUserId));
        if (!userDoc.exists()) {
          console.log("No user document found");
          return;
        }

        const userData = userDoc.data();
        setUserData(userData);
        // Determine which ID to use for employee check
        const idToCheck = employeeDetails?.id || selectedUserId;

        // Get the partner document and check employee
        if (userData.partner_id) {
          // Check employee in the partner's employees subcollection
          const employeeDoc = await getDoc(
            doc(db, "partners", userData.partner_id, "employees", idToCheck)
          );

          if (employeeDoc.exists()) {
            const employeeData = employeeDoc.data();
            const role = employeeDetails?.role;
            setUserData({ ...userData, name_of_org: employeeData.name_of_org });
            setEmployeeRole(role);

            // Strict role-based access control
            if (role === "Case Manager") {
              await fetchAssignedCases(idToCheck, userData.partner_id);
            } else if (
              role === "Admin" ||
              role === "Case Supervisor" ||
              employeeDetails?.is_admin
            ) {
              await fetchAllCases(userData.partner_id);
            }
          }
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    };

    fetchUserData();
  }, [employeeId]); // Add employeeId to dependencies

  // Add these helper functions for fetching cases
  const fetchAllCases = async (partnerId) => {
    try {
      const caseManagementRef = collection(db, "case_management");
      const caseQuery = query(
        caseManagementRef,
        where("assigned_to_org_uid", "==", partnerId)
      );

      const caseSnapshot = await getDocs(caseQuery);
      const cases = await Promise.all(
        caseSnapshot.docs.map(async (caseDoc) => {
          const caseData = caseDoc.data();
          try {
            const citizenRef = doc(db, "users", caseData.citizen_id);
            const citizenDoc = await getDoc(citizenRef);

            if (citizenDoc.exists()) {
              return {
                id: citizenDoc.id,
                ...citizenDoc.data(),
                ...caseData,
              };
            }
            console.warn(
              `Citizen document not found for ID: ${caseData.citizen_id}`
            );
            return null;
          } catch (err) {
            console.error(
              `Error fetching citizen data for case ${caseDoc.id}:`,
              err
            );
            return null;
          }
        })
      );

      const filteredCases = cases.filter(Boolean);

      // Process and map citizen data
      const formattedData = await mapCitizenData(filteredCases);

      setGridData(formattedData);
    } catch (error) {
      console.error("Error fetching all cases:", error);
      setGridData([]); // Set empty array on error
    }
  };

  const fetchAssignedCases = async (employeeId, partnerId) => {
    try {
      if (!employeeId || !partnerId) {
        console.error("Missing required parameters:", {
          employeeId,
          partnerId,
        });
        return;
      }

      const caseManagementRef = collection(db, "case_management");
      const caseQuery = query(
        caseManagementRef,
        where("assigned_to_case_manager_uid", "==", employeeId),
        where("assigned_to_org_uid", "==", partnerId)
      );

      const caseSnapshot = await getDocs(caseQuery);

      if (caseSnapshot.empty) {
        setGridData([]);
        return;
      }

      const cases = await Promise.all(
        caseSnapshot.docs.map(async (caseDoc) => {
          try {
            const caseData = caseDoc.data();
            if (!caseData.citizen_id) {
              console.warn("Case missing citizen_id:", caseDoc.id);
              return null;
            }

            const citizenRef = doc(db, "users", caseData.citizen_id);
            const citizenDoc = await getDoc(citizenRef);

            if (!citizenDoc.exists()) {
              console.warn("Citizen document not found:", caseData.citizen_id);
              return null;
            }

            return {
              id: citizenDoc.id,
              ...citizenDoc.data(),
              ...caseData,
            };
          } catch (err) {
            console.error("Error processing case document:", err);
            return null;
          }
        })
      );

      const filteredCases = cases.filter(Boolean);

      // Process and map citizen data
      const formattedData = await mapCitizenData(filteredCases);

      setGridData(formattedData);
    } catch (error) {
      console.error("Error fetching assigned cases:", error);
      setGridData([]); // Set empty array on error
    }
  };

  // Modify the employees fetch useEffect
  useEffect(() => {
    const fetchEmployees = async () => {
      try {
        if (!userData?.partner_id) {
          console.log("No partner ID available", userData);
          return;
        }

        const employeesRef = collection(
          db,
          "partners",
          userData.partner_id,
          "employees"
        );

        const employeesSnapshot = await getDocs(employeesRef);

        const employeesData = employeesSnapshot.docs.map((doc) => {
          const data = doc.data();
          return {
            id: doc.id,
            ...data,
            fullName: `${data.first_name} ${data.last_name}`,
          };
        });

        setEmployees(employeesData);
      } catch (error) {
        console.error("Error fetching employees:", error);
      }
    };

    if (userData?.partner_id) {
      fetchEmployees();
    }
  }, [userData]);

  useEffect(() => {
    const fetchDisasters = async () => {
      try {
        // First get the current user's partner details
        const auth = getAuth();
        const userDoc = await getDoc(doc(db, "users", selectedUserId));
        const partnerId = userDoc.data()?.partner_id;

        if (!partnerId) {
          console.warn("Partner ID not found");
          return;
        }

        // Get partner's service area counties
        const partnerDoc = await getDoc(doc(db, "partners", partnerId));
        setPartnerDoc(partnerDoc.data());
        const serviceAreaCounties = partnerDoc.data()?.county || [];

        if (serviceAreaCounties.length === 0) {
          console.warn("No service area counties found for partner");
          return;
        }

        // Fetch disasters and filter based on matching counties
        const disastersQuery = query(collection(db, "declared-disaster"));
        const querySnapshot = await getDocs(disastersQuery);
        const fetchedDisasters = querySnapshot.docs
          .map((doc) => ({
            id: doc.id,
            name: doc.data().disaster_name,
            status: doc.data().disaster_status,
            disaster_type: doc.data().disaster_type,
            county: doc.data().disaster_county,
            state: doc.data().disaster_state,
            affected_counties: doc.data().affected_counties || [],
          }))
          .filter((disaster) =>
            // Check if any of the partner's service area counties
            // intersect with the disaster's affected counties
            disaster.affected_counties.some((county) =>
              serviceAreaCounties.includes(county)
            )
          );

        // Sort disasters by status: active first, then inactive, then closed
        const activeDisasters = fetchedDisasters.filter(
          (disaster) => disaster.status === "active"
        );
        const inactiveDisasters = fetchedDisasters.filter(
          (disaster) => disaster.status === "inactive"
        );
        const closedDisasters = fetchedDisasters.filter(
          (disaster) => disaster.status === "closed"
        );

        const sortedDisasters = [
          ...activeDisasters,
          ...inactiveDisasters,
          ...closedDisasters,
        ];

        // Add matching counties information to each disaster
        const disastersWithMatchingCounties = sortedDisasters.map(
          (disaster) => ({
            ...disaster,
            matching_counties: disaster.affected_counties.filter((county) =>
              serviceAreaCounties.includes(county)
            ),
          })
        );

        setActiveDisasters(activeDisasters.map((disaster) => disaster.id));
        setDisasterOptions(disastersWithMatchingCounties);
        if (activeDisasters.length > 0) {
          setSelectedDisasters([activeDisasters[0].id]);
        }

        // Fetch statistics for the disasters
        await fetchDisasterStats(disastersWithMatchingCounties);
      } catch (error) {
        console.error("Error fetching disasters:", error);
      }
    };

    fetchDisasters();
  }, [userData?.partner_id]); // Changed dependency to partner_id

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const fetchDisasterStats = async (disasters) => {
    try {
      if (!disasters || disasters.length === 0 || !userData?.partner_id) {
        console.log("No disasters provided or no partner ID");
        return [];
      }

      const stats = await Promise.all(
        disasters.map(async (disaster) => {
          // Get all cases from case_management for this disaster assigned to this partner
          const casesQuery = query(
            collection(db, "case_management"),
            where("disaster_id", "==", disaster.id),
            where("assigned_to_org_uid", "==", userData.partner_id)
          );
          const casesSnapshot = await getDocs(casesQuery);

          // Create a Map to store case details
          const caseDetails = new Map();

          // Get citizen details for each case
          for (const caseDoc of casesSnapshot.docs) {
            const caseData = caseDoc.data();
            const userDoc = await getDoc(doc(db, "users", caseData.citizen_id));

            if (userDoc.exists()) {
              const userData = userDoc.data();
              caseDetails.set(caseData.case_number, {
                case_number: caseData.case_number,
                client_name: `${userData.first_name} ${userData.last_name}`,
                client_id: userDoc.id,
                email: userData.email,
                phone: userData.mobile_number,
                address: `${userData.address1}${
                  userData.address2 ? `, ${userData.address2}` : ""
                }, ${userData.city}, ${userData.state} ${userData.zip}`,
                status: caseData.status || "Open",
                assigned_to: caseData.assigned_to_case_manager || "",
                assigned_to_uid: caseData.assigned_to_case_manager_uid || "",
                county: userData.county || "Unspecified",
                assignment_date: caseData.assignment_date || "",
              });
            }
          }

          // Group cases by county
          const casesByCounty = new Map();
          caseDetails.forEach((caseItem) => {
            const county = caseItem.county;
            if (!casesByCounty.has(county)) {
              casesByCounty.set(county, {
                county: county,
                disaster_name: disaster.name,
                disaster_id: disaster.id,
                status: disaster.status,
                cases: [],
                open_cases: 0,
                unassigned_cases: 0,
                total_cases: 0,
              });
            }

            const countyStats = casesByCounty.get(county);
            countyStats.cases.push(caseItem);
            countyStats.total_cases++;
            if (caseItem.status === "Open") countyStats.open_cases++;
            if (!caseItem.assigned_to_uid) countyStats.unassigned_cases++;
          });

          // Calculate caseManager statistics
          const caseManagerStats = new Map();
          caseDetails.forEach((caseItem) => {
            if (caseItem.assigned_to) {
              if (!caseManagerStats.has(caseItem.assigned_to)) {
                caseManagerStats.set(caseItem.assigned_to, {
                  name: caseItem.assigned_to,
                  assigned_cases: 0,
                });
              }
              caseManagerStats.get(caseItem.assigned_to).assigned_cases++;
            }
          });

          // Format the final statistics
          return {
            disaster_name: disaster.name,
            disaster_id: disaster.id,
            status: disaster.status,
            counties: Array.from(casesByCounty.values()),
            open_cases: Array.from(caseDetails.values()).filter(
              (c) => c.status === "Open"
            ).length,
            unassigned_cases: Array.from(caseDetails.values()).filter(
              (c) => !c.assigned_to_uid
            ).length,
            total_cases: caseDetails.size,
            caseManagers: Array.from(caseManagerStats.values()),
          };
        })
      );

      const validStats = stats.filter((stat) => stat !== null);
      setDisasterStats(validStats);
      return validStats;
    } catch (error) {
      console.error("Error fetching disaster statistics:", error);
      return [];
    }
  };

  // Update the useEffect to use this function
  useEffect(() => {
    if (!userData?.partner_id || !disasterOptions.length) return;

    fetchDisasterStats(disasterOptions);
  }, [userData?.partner_id, disasterOptions]);

  useEffect(() => {
    const auth = getAuth();

    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      if (currentUser && selectedUserId) {
        setUserId(selectedUserId);
      } else {
        console.log("No user is logged in");
      }
    });

    return () => unsubscribe();
  }, []);

  // useEffect(() => {
  //   const fetchData = async () => {
  //     try {
  //       if (!selectedUserId) return;
  //       setIsLoading(true);

  //       // Get user data
  //       const userRef = doc(db, "users", selectedUserId);
  //       const userDoc = await getDoc(userRef);

  //       if (!userDoc.exists()) {
  //         setIsLoading(false);
  //         return;
  //       }

  //       const userData = userDoc.data();
  //       const partnerId = userData.partner_id;

  //       if (!partnerId) {
  //         setIsLoading(false);
  //         return;
  //       }

  //       // Query for cases assigned to the partner organization
  //       const caseManagementRef = collection(db, "case_management");
  //       const caseQuery = query(
  //         caseManagementRef,
  //         where("assigned_to_org_uid", "==", partnerId),
  //         where("assigned_to_case_manager_uid", "==", employeeDetails?.id)
  //       );

  //       const caseSnapshot = await getDocs(caseQuery);
  //       console.log("Found cases:", caseSnapshot.size);

  //       if (caseSnapshot.empty) {
  //         setGridData([]);
  //         setIsLoading(false);
  //         return;
  //       }

  //       // Process cases one by one
  //       const processedCases = [];
  //       for (const caseDoc of caseSnapshot.docs) {
  //         const caseData = caseDoc.data();
  //         try {
  //           const citizenRef = doc(db, "users", caseData.citizen_id);
  //           const citizenDoc = await getDoc(citizenRef);

  //           if (citizenDoc.exists()) {
  //             const citizenData = citizenDoc.data();
  //             processedCases.push({
  //               id: citizenDoc.id,
  //               name: `${citizenData.first_name} ${citizenData.last_name}`,
  //               case_number: caseData.case_number,
  //               county: citizenData.county || "Unknown",
  //               status: caseData.status || "Open",
  //               assigned_to_case_manager:
  //                 caseData.assigned_to_case_manager || "Unassigned",
  //               assigned_to_org: caseData.assigned_to_org || "Unassigned", // Add this line
  //               assigned_to_org_uid: caseData.assigned_to_org_uid || "", // Add this line
  //               assignment_date: caseData.assignment_date || "",
  //               citizen_id: caseData.citizen_id,
  //               disaster_id: caseData.disaster_id,
  //               disaster_name: caseData.disaster_name || "",
  //             });
  //           }
  //         } catch (error) {
  //           console.error("Error processing case:", error);
  //         }
  //       }

  //       console.log("Processed cases:", processedCases.length);
  //       setGridData(processedCases);
  //       setIsLoading(false);
  //     } catch (error) {
  //       console.error("Error in fetchData:", error);
  //       setIsLoading(false);
  //     }
  //   };

  //   fetchData();
  // }, [selectedUserId]);

  const mapCitizenData = async (citizens) => {
    try {
      // 1. Batch fetch all survey responses and impacted addresses in parallel
      const batchPromises = citizens.map((citizen) => ({
        id: citizen.id,
        surveyPromise: getDocs(
          query(collection(db, `users/${citizen.id}/survey_responses`))
        ),
        addressPromise: getDocs(
          query(collection(db, `users/${citizen.id}/impacted-addresses`))
        ),
      }));

      // Execute all promises in parallel
      const citizenData = await Promise.all(
        batchPromises.map(async ({ id, surveyPromise, addressPromise }) => {
          const [surveySnapshot, addressSnapshot] = await Promise.all([
            surveyPromise,
            addressPromise,
          ]);

          // Create maps for faster lookups
          const impactedAddresses = new Map();
          addressSnapshot.forEach((doc) => {
            const addressData = doc.data();
            if (addressData.disaster_id) {
              impactedAddresses.set(addressData.disaster_id, addressData);
            }
          });

          // Group surveys by case number and collect case numbers
          const caseGroups = new Map();
          surveySnapshot.forEach((doc) => {
            const surveyData = doc.data();
            if (surveyData.disasters && surveyData.case_number) {
              caseGroups.set(surveyData.case_number, surveyData.disasters);
            }
          });

          return {
            id,
            citizen: citizens.find((c) => c.id === id),
            caseGroups,
            impactedAddresses,
          };
        })
      );

      // 2. Collect all unique case numbers
      const allCaseNumbers = [
        ...new Set(
          citizenData.flatMap(({ caseGroups }) => Array.from(caseGroups.keys()))
        ),
      ];

      // 3. Batch fetch all case management data at once
      const caseManagementMap = new Map();
      if (allCaseNumbers.length > 0) {
        // Split into chunks of 10 (Firestore limitation)
        const chunkSize = 10;
        for (let i = 0; i < allCaseNumbers.length; i += chunkSize) {
          const chunk = allCaseNumbers.slice(i, i + chunkSize);
          const caseManagementQuery = query(
            collection(db, "case_management"),
            where("case_number", "in", chunk)
          );
          const snapshot = await getDocs(caseManagementQuery);
          snapshot.forEach((doc) => {
            const data = doc.data();
            caseManagementMap.set(data.case_number, data);
          });
        }
      }

      // 4. Map final data
      const mappedCitizens = [];
      citizenData.forEach(({ id, citizen, caseGroups, impactedAddresses }) => {
        caseGroups.forEach((disasters, caseNumber) => {
          const caseManagementData = caseManagementMap.get(caseNumber) || {};
          const disasterId = disasters[0].disaster_id;
          const impactedAddress = impactedAddresses.get(disasterId);

          mappedCitizens.push({
            id,
            name: impactedAddress
              ? `${impactedAddress.first_name} ${impactedAddress.last_name}`
              : `${citizen.first_name} ${citizen.last_name}`,
            address: impactedAddress
              ? `${impactedAddress.address1}${
                  impactedAddress.address2
                    ? `, ${impactedAddress.address2}`
                    : ""
                }, ${impactedAddress.city}, ${impactedAddress.state}, ${
                  impactedAddress.zip
                }`
              : `${citizen.address1}${
                  citizen.address2 ? `, ${citizen.address2}` : ""
                }, ${citizen.city}, ${citizen.state}, ${citizen.zip}`,
            mobile_number: impactedAddress?.phone || citizen.mobile_number,
            email: impactedAddress?.email || citizen.email,
            county: impactedAddress?.county || citizen.county || "Unspecified",
            state: impactedAddress?.state || citizen.state || "Unspecified",

            // Case and disaster info
            citizen_id: citizen.citizen_id,
            case_number: caseNumber,
            disaster_id: disasters[0].disaster_id,
            disaster_name: disasters.map((d) => d.disaster_name).join(", "),

            // Case management info
            assigned_to: caseManagementData.assigned_to_case_manager || "",
            assigned_to_uid:
              caseManagementData.assigned_to_case_manager_uid || "",
            assigned_to_case_manager:
              caseManagementData.assigned_to_case_manager || "",
            assigned_to_case_manager_uid:
              caseManagementData.assigned_to_case_manager_uid || "",
            assigned_to_org: caseManagementData.assigned_to_org || "",
            assigned_to_org_uid: caseManagementData.assigned_to_org_uid || "",
            assignment_type: caseManagementData.assignment_type || "",
            assignment_date: caseManagementData.assignment_date || "",
            status: caseManagementData.status || "Open",
            status_date:
              caseManagementData.updated_at ||
              caseManagementData.assignment_date ||
              "",

            impacted_address: impactedAddress || null,
          });
        });
      });

      return mappedCitizens;
    } catch (error) {
      console.error("Error in mapCitizenData:", error);
      return [];
    }
  };

  const handleCommandClick = async (args) => {
    if (args.commandColumn.type === "View") {
      try {
        if (!userId) {
          console.error("User ID is not set. Cannot update document.");
          return;
        }

        const rowData = args.rowData;

        if (!rowData) {
          console.error("No row data available.");
          return;
        }

        const citizen_id = rowData.citizen_id;
        const case_number = rowData.case_number;
        const disaster_id = rowData.disaster_id;

        const userDocRef = doc(db, "users", userId);

        // Store both the accessed_userId and the case number
        await updateDoc(userDocRef, {
          accessed_userId: citizen_id,
          accessed_case_number: case_number,
          accessed_disaster_id: disaster_id,
        });

        // Store the accessed_userId in sessionStorage for reference
        sessionStorage.setItem("accessedUserId", citizen_id);

        // Different navigation path for partners
        navigate("/partnercasemanagement/disastermanagement");
      } catch (error) {
        console.error("Error in handleCommandClick: ", error);
      }
    } else if (args.commandColumn.type === "Assign") {
      const rowData = args.rowData;
      setSelectedCase(args.rowData);
      setDropdownValue(
        employees.find(
          (emp) => emp.id === args.rowData.assigned_to_case_manager_uid
        )?.id
      );
      setSelectedStatus(args.rowData.status || "Open");
      setAssignDialogOpen(true);
    } else if (args.commandColumn.type === "Access") {
      // Handle Access Account functionality
      const citizenData = args.rowData;

      // Store necessary information in localStorage
      localStorage.setItem("accessAccountEmail", citizenData.email);
      localStorage.setItem("orgUserId", userId);
      localStorage.setItem("orgType", "partner");

      // Open in new tab
      window.open(window.location.origin + "/accessaccount", "_blank");
    }
  };

  const handleAssign = async () => {
    try {
      if (!selectedCase) {
        console.error("No case selected");
        return;
      }

      // Check if a case management record exists
      const caseManagementRef = collection(db, "case_management");
      const q = query(
        caseManagementRef,
        where("case_number", "==", selectedCase.case_number),
        where("citizen_id", "==", selectedCase.citizen_id)
      );
      const querySnapshot = await getDocs(q);

      const currentDate = new Date().toISOString();

      // Prepare update data based on assignment type
      const updateData = {
        updated_at: currentDate,
        status: selectedStatus,
      };

      if (assignmentType === "Unassign") {
        // Only clear case manager fields when unassigning, keep organization assignment
        updateData.assigned_to_case_manager = "";
        updateData.assigned_to_case_manager_uid = "";
        // Keep organization assignment intact
        // Do NOT clear assigned_to_org or assigned_to_org_uid
      } else {
        // Regular assignment - require selected employee
        if (!selectedEmployee) {
          console.error("No employee selected for assignment");
          return;
        }
        updateData.assigned_to_case_manager = `${selectedEmployee.first_name} ${selectedEmployee.last_name}`;
        updateData.assigned_to_case_manager_uid = selectedEmployee.id;
        updateData.assignment_date = currentDate; // Add assignment date for new assignments
        // Keep the organization assignment
        updateData.assigned_to_org = partnerDoc?.name_of_org || "";
        updateData.assigned_to_org_uid = userData?.partner_id;
      }

      if (querySnapshot.empty) {
        console.error("No case management record found to update");
        return;
      } else {
        // Update existing record
        const existingDoc = querySnapshot.docs[0];

        await updateDoc(doc(db, "case_management", existingDoc.id), updateData);
        if (employeeDetails?.user_role === "employee") {
          fetchAssignedCases(employeeDetails.id, userData?.partner_id);
        } else {
          fetchAllCases(userData?.partner_id);
        }
      }

      setAssignDialogOpen(false);

      // Reset selections
      setSelectedEmployee(null);
      setSelectedStatus("Open");
      setAssignmentType("Case Manager"); // Reset assignment type
    } catch (error) {
      console.error("Error updating case assignment:", error);
    }
  };

  // Add this effect to refresh the grid when selection changes
  useEffect(() => {
    const gridInstance = gridRef.current;
    if (gridInstance) {
      gridInstance.refresh();
    }
  }, [selectedRecords]);

  const assignAll = (data) => {
    // Get all items from the group
    const groupItems = data.items;

    // Create a summary object for the group
    const groupSummary = {
      isMultiple: true,
      cases: groupItems.map((item) => ({
        case_number: item.case_number,
        name: item.client_name || item.name, // Add fallback for name
        county: item.county,
        address: item.address,
        email: item.email,
        phone: item.phone || item.mobile_number, // Add fallback for phone
        status: item.status,
        assigned_to: item.assigned_to,
        assigned_company: item.assigned_company,
        disaster_id: item.disaster_id,
        disaster_name: item.disaster_name,
        citizen_id: item.citizen_id,
      })),
      name: `${data.count} cases from ${data.field}: ${
        data.items[0][data.field]
      }`,
      case_number: `Multiple (${data.count})`,
      county:
        data.field === "county"
          ? data.items[0][data.field]
          : "Multiple Counties",
    };

    // Set the selected case and open assign dialog
    setSelectedCase(groupSummary);
    setAssignDialogOpen(true);
  };

  // Update the handleGroupSelection function
  const handleGroupSelection = (data) => {
    const selectedRecords = gridRef.current?.getSelectedRecords() || [];
    const groupRecords = selectedRecords.filter(
      (record) => record[data.field] === data.items[0][data.field]
    );

    if (groupRecords.length === 0) {
      console.log("No records selected in this group");
      return;
    }

    // Create a summary object for the selected records
    const groupSummary = {
      isMultiple: true,
      cases: groupRecords.map((record) => ({
        case_number: record.case_number,
        name: record.name || record.client_name,
        county: record.county,
        address: record.address,
        email: record.email,
        phone: record.phone || record.mobile_number,
        status: record.status,
        assigned_to: record.assigned_to,
        assigned_company: record.assigned_company,
        disaster_id: record.disaster_id,
        disaster_name: record.disaster_name,
        citizen_id: record.citizen_id,
      })),
      groupInfo: {
        field: data.field,
        value: data.items[0][data.field],
        displayValue: `${data.field}: ${data.items[0][data.field]}`,
      },
      name: `${groupRecords.length} selected cases from ${data.field}: ${
        data.items[0][data.field]
      }`,
      case_number: `Multiple (${groupRecords.length})`,
      county:
        data.field === "county"
          ? data.items[0][data.field]
          : "Multiple Counties",
    };

    setSelectedCase(groupSummary);
    setAssignDialogOpen(true);
  };

  const selectionHandler = (args) => {
    const gridInstance = gridRef.current;
    if (!gridInstance) return;

    // Get current selected records
    const selectedRecords = gridInstance.getSelectedRecords() || [];
    setSelectedRecords(selectedRecords);

    // Only handle group selection if this was triggered by a group checkbox
    if (args.target && args.target.classList.contains("group-checkbox")) {
      const groupField = gridInstance.groupSettings.columns[0];
      if (groupField) {
        const groupValue = args.data[groupField];

        // Get all records in the current group
        const allGroupRecords = gridInstance
          .getCurrentViewRecords()
          .filter((record) => record[groupField] === groupValue);

        // Check if all records in the group are selected
        const allSelected = allGroupRecords.every((record) =>
          selectedRecords.some((selected) => selected.id === record.id)
        );

        // Update group selection
        if (args.isInteracted) {
          if (!allSelected) {
            // Select all records in the group
            allGroupRecords.forEach((record) => {
              if (
                !selectedRecords.some((selected) => selected.id === record.id)
              ) {
                gridInstance.selectRows([
                  gridInstance.getRowIndexByPrimaryKey(record.id),
                ]);
              }
            });
          } else {
            // Deselect all records in the group
            allGroupRecords.forEach((record) => {
              gridInstance.selectRows(
                [gridInstance.getRowIndexByPrimaryKey(record.id)],
                false
              );
            });
          }
        }
      }
    }

    // Force refresh of group captions
    gridInstance.refreshHeader();
  };

  const captionRow = (data) => {
    return `${data.items[0][data.field]}` + " - " + data.count;
  };

  const groupCaptionTemplate = (data) => {
    const gridInstance = gridRef.current;
    if (!gridInstance) return null;

    // Get all records in this group
    const allGroupRecords = gridInstance
      .getCurrentViewRecords()
      .filter((record) => record[data.field] === data.items[0][data.field]);

    // Get currently selected records
    const selectedRecords = gridInstance.getSelectedRecords() || [];

    // Count how many records from this group are selected
    const selectedInGroup = selectedRecords.filter(
      (record) => record[data.field] === data.items[0][data.field]
    ).length;

    // Calculate selection states
    const isAllSelected =
      selectedInGroup === allGroupRecords.length && allGroupRecords.length > 0;
    const isPartiallySelected =
      selectedInGroup > 0 && selectedInGroup < allGroupRecords.length;

    return (
      <div className="flex w-full items-center justify-between px-4 py-2">
        <div className="flex items-center gap-2">
          {/* <input
            type="checkbox"
            checked={isAllSelected}
            ref={input => {
              if (input) {
                input.indeterminate = isPartiallySelected;
              }
            }}
            onChange={(e) => {
              e.stopPropagation();
              toggleGroupSelection(e, data);
            }}
            className="form-checkbox h-4 w-4 text-blue-600 rounded group-checkbox"
          /> */}
          <span className="text-gray-700">{captionRow(data)}</span>
        </div>
        <div className="flex gap-2">
          <button
            className="rounded-full bg-green-500 px-3 py-1 text-xs font-medium text-white hover:bg-green-600"
            onClick={(e) => {
              e.stopPropagation();
              handleGroupSelection(data);
            }}
          >
            Assign Selected {selectedInGroup > 0 ? `(${selectedInGroup})` : ""}
          </button>
          <button
            className="rounded-full bg-blue-500 px-3 py-1 text-xs font-medium text-white hover:bg-blue-600"
            onClick={(e) => {
              e.stopPropagation();
              assignAll(data);
            }}
          >
            Assign All ({data.count})
          </button>
        </div>
      </div>
    );
  };

  const toggleGroupSelection = (event, data) => {
    const gridInstance = gridRef.current;
    if (!gridInstance) return;

    event.preventDefault();
    event.stopPropagation();

    const groupField = data.field;
    const groupValue = data.items[0][groupField];

    // Get all records in the current group
    const allGroupRecords = gridInstance
      .getCurrentViewRecords()
      .filter((record) => record[groupField] === groupValue);

    // Get current selected records
    const selectedRecords = gridInstance.getSelectedRecords() || [];

    // Check if all records in this group are currently selected
    const allSelected = allGroupRecords.every((record) =>
      selectedRecords.some((selected) => selected.id === record.id)
    );

    // Get the row indexes for all records in this group
    const indexes = allGroupRecords
      .map((record) => gridInstance.getRowIndexByPrimaryKey(record.id))
      .filter((index) => index !== -1);

    if (!allSelected) {
      // Select all records in group
      gridInstance.selectRows(indexes);
    } else {
      // Deselect all records in group
      gridInstance.selectRows(indexes, false);
    }

    // Force refresh of the grid UI
    gridInstance.refresh();
  };

  const handleOptionClick = (option) => {
    setSelectedOption(option);
    setDropdownOpen(false);
  };

  const handleCheckboxChange = (id) => {
    setSelectedDisasters((prevSelected) =>
      prevSelected.includes(id)
        ? prevSelected.filter((disasterId) => disasterId !== id)
        : [...prevSelected, id]
    );
  };

  const togglePanel = () => {
    if (openPanel) {
      setOpenPanel(false);
    } else {
      setOpenPanel(true);
    }
  };

  const applyFilter = () => {};

  const applySort = () => {};

  return (
    <div className="flex max-h-[calc(100vh-10px)]">
      {/* Fixed Sidebar */}
      <div className="pointer-events-none fixed left-0 top-0 z-40 flex h-full pt-[6vh]">
        {/* Icon Sidebar - Higher z-index to stay on top */}
        <div className="pointer-events-auto relative z-50 flex w-[246px] flex-shrink-0 flex-col items-center space-y-4 border-r border-solid border-[#CFCFCF] bg-[#ffffff] py-4 pb-10">
          <div className="flex h-full w-full flex-col items-center justify-between px-2 ">
            <div className="flex w-full flex-col items-center space-y-1">
              <svg
                width="100"
                height="101"
                viewBox="0 0 100 101"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M32.3442 26.7812L38.614 28.8721L34.4318 33.0601L32.3442 26.7812Z"
                  fill="#003460"
                />
                <path
                  d="M67.6337 62.6491L61.3647 60.5552L65.5434 56.3672L67.6337 62.6491Z"
                  fill="#003460"
                />
                <path
                  d="M32.3442 62.6491L34.4318 56.3672L38.614 60.5552L32.3442 62.6491Z"
                  fill="#003460"
                />
                <path
                  d="M15.2468 41.4352C13.8581 34.8479 13.4669 29.009 13.4412 24.7565C21.0322 17.7003 33.2094 13.3099 46.7238 12.6964L47.2461 6.8125C31.4677 7.37457 17.1164 12.7478 8.45107 21.442L7.60765 22.2867L7.59481 23.4814C7.55637 27.1974 7.81291 33.8073 9.45487 41.7562L15.2468 41.4352Z"
                  fill="#86181A"
                />
                <path
                  d="M53.2649 12.6964C66.7758 13.3099 78.9529 17.7003 86.5468 24.7565C86.5215 29.009 86.1337 34.8479 84.7414 41.4352L90.5334 41.7562C92.1755 33.8073 92.4323 27.1974 92.3939 23.4814L92.3808 22.2867L91.537 21.442C82.8721 12.7511 68.5175 7.37457 52.7417 6.8125L53.2649 12.6964Z"
                  fill="#86181A"
                />
                <path
                  d="M83.1511 47.7167C79.1515 61.1803 70.6596 76.507 52.9796 87.7804L52.4922 94.8875C74.957 82.0504 84.8762 63.024 89.1798 47.3828L83.1511 47.7167Z"
                  fill="#86181A"
                />
                <path
                  d="M47.0172 87.7769C29.3372 76.5069 20.8451 61.1803 16.846 47.7167L10.8169 47.3828C15.1239 63.0272 25.0399 82.0504 47.5055 94.8875L47.0172 87.7804V87.7769Z"
                  fill="#86181A"
                />
                <path
                  d="M54.5678 27.3244C60.8787 29.0076 65.8112 34.0725 67.3092 40.4639L69.519 40.5859C67.973 32.8937 61.9888 26.8042 54.3687 25.0859L54.5678 27.3244Z"
                  fill="#FDB841"
                />
                <path
                  d="M32.6816 40.4639C34.1796 34.0725 39.1112 29.0076 45.4229 27.3244L45.6221 25.0859C38.0019 26.8042 32.0203 32.8937 30.4717 40.5859L32.6816 40.4639Z"
                  fill="#FDB841"
                />
                <path
                  d="M45.2142 61.6795C39.0029 59.9419 34.163 54.9156 32.6816 48.5947L30.4717 48.4727C32.002 56.0782 37.8709 62.11 45.3688 63.9052L45.2142 61.6795Z"
                  fill="#FDB841"
                />
                <path
                  d="M67.3045 48.5947C65.8231 54.9156 60.984 59.9419 54.7719 61.6795L54.6182 63.9052C62.1126 62.11 67.9814 56.075 69.5109 48.4727L67.3019 48.5947H67.3045Z"
                  fill="#FDB841"
                />
                <path
                  d="M44.334 39.8303L44.9498 32.8672H44.9209H37.8301V37.8712V40.1932L44.334 39.8303Z"
                  fill="#003460"
                />
                <path
                  d="M55.6907 39.8341L64.7181 40.3349C64.6185 40.0362 64.5189 39.7408 64.3975 39.4583C63.759 38.0033 62.813 36.7829 61.5526 35.8065C60.2922 34.8269 58.7147 34.0946 56.8193 33.6032C56.2768 33.4618 55.703 33.3494 55.1099 33.25L55.6933 39.8341H55.6907Z"
                  fill="#003460"
                />
                <path
                  d="M44.3785 49.2574L37.8301 48.8945V51.2132V56.2171H44.8563L44.3785 49.2574Z"
                  fill="#003460"
                />
                <path
                  d="M55.6356 49.2589L55.1831 55.8236C55.7439 55.7274 56.2898 55.6151 56.806 55.4833C58.7015 54.9952 60.2824 54.2596 61.5394 53.2832C62.7998 52.3036 63.7458 51.0864 64.3843 49.6315C64.5057 49.3519 64.6053 49.0533 64.7048 48.7578L55.6321 49.2621L55.6356 49.2589Z"
                  fill="#003460"
                />
                <path
                  d="M54.1658 50.4061L49.9932 45.9258L45.8346 50.4093C45.7988 50.4447 45.7569 50.4606 45.7158 50.4896L50.0002 100.359L54.2846 50.4864C54.2461 50.4574 54.2007 50.4415 54.1658 50.4061Z"
                  fill="#003460"
                />
                <path
                  d="M45.8332 37.8118L50.0049 42.2923L54.1644 37.8085C54.1644 37.8085 54.1906 37.796 54.2002 37.783L49.9988 0L45.7974 37.783C45.7974 37.783 45.8236 37.7992 45.8358 37.8085L45.8332 37.8118Z"
                  fill="#003460"
                />
                <path
                  d="M55.6103 40.5742L51.8159 44.1169L56.2933 48.2823C56.3353 48.3242 56.3571 48.3756 56.3894 48.4237L99.7967 44.5343L55.6103 40.5742Z"
                  fill="#477EA6"
                />
                <path
                  d="M43.7091 48.2786L48.183 44.1L44.3921 40.5703L0.203125 44.5304L43.613 48.4198C43.6453 48.3717 43.668 48.3171 43.7091 48.2753V48.2786Z"
                  fill="#477EA6"
                />
                <path
                  d="M67.6337 26.7812L65.5434 33.0601L61.3647 28.8721L67.6337 26.7812Z"
                  fill="#003460"
                />
              </svg>
              <button
                onClick={() => {
                  setActiveView("dashboard");
                  setSidebarOpen(false);
                }}
                className={`flex w-full cursor-pointer items-center justify-start space-x-2 rounded-lg p-2 ${
                  activeView === "dashboard" ? "bg-[#003460]" : "bg-[#ffffff]"
                }`}
                title="Dashboard"
              >
                <svg
                  width="20"
                  height="19"
                  viewBox="0 0 20 19"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1 18.3594C0.716667 18.3594 0.479167 18.2635 0.2875 18.0719C0.0958333 17.8802 0 17.6427 0 17.3594C0 17.076 0.0958333 16.8385 0.2875 16.6469C0.479167 16.4552 0.716667 16.3594 1 16.3594H19C19.2833 16.3594 19.5208 16.4552 19.7125 16.6469C19.9042 16.8385 20 17.076 20 17.3594C20 17.6427 19.9042 17.8802 19.7125 18.0719C19.5208 18.2635 19.2833 18.3594 19 18.3594H1ZM2.5 15.3594C2.08333 15.3594 1.72917 15.2135 1.4375 14.9219C1.14583 14.6302 1 14.276 1 13.8594V9.85938C1 9.44271 1.14583 9.08854 1.4375 8.79688C1.72917 8.50521 2.08333 8.35938 2.5 8.35938C2.91667 8.35938 3.27083 8.50521 3.5625 8.79688C3.85417 9.08854 4 9.44271 4 9.85938V13.8594C4 14.276 3.85417 14.6302 3.5625 14.9219C3.27083 15.2135 2.91667 15.3594 2.5 15.3594ZM7.5 15.3594C7.08333 15.3594 6.72917 15.2135 6.4375 14.9219C6.14583 14.6302 6 14.276 6 13.8594V4.85938C6 4.44271 6.14583 4.08854 6.4375 3.79688C6.72917 3.50521 7.08333 3.35938 7.5 3.35938C7.91667 3.35938 8.27083 3.50521 8.5625 3.79688C8.85417 4.08854 9 4.44271 9 4.85938V13.8594C9 14.276 8.85417 14.6302 8.5625 14.9219C8.27083 15.2135 7.91667 15.3594 7.5 15.3594ZM12.5 15.3594C12.0833 15.3594 11.7292 15.2135 11.4375 14.9219C11.1458 14.6302 11 14.276 11 13.8594V7.85938C11 7.44271 11.1458 7.08854 11.4375 6.79688C11.7292 6.50521 12.0833 6.35938 12.5 6.35938C12.9167 6.35938 13.2708 6.50521 13.5625 6.79688C13.8542 7.08854 14 7.44271 14 7.85938V13.8594C14 14.276 13.8542 14.6302 13.5625 14.9219C13.2708 15.2135 12.9167 15.3594 12.5 15.3594ZM17.5 15.3594C17.0833 15.3594 16.7292 15.2135 16.4375 14.9219C16.1458 14.6302 16 14.276 16 13.8594V1.85938C16 1.44271 16.1458 1.08854 16.4375 0.796875C16.7292 0.505208 17.0833 0.359375 17.5 0.359375C17.9167 0.359375 18.2708 0.505208 18.5625 0.796875C18.8542 1.08854 19 1.44271 19 1.85938V13.8594C19 14.276 18.8542 14.6302 18.5625 14.9219C18.2708 15.2135 17.9167 15.3594 17.5 15.3594Z"
                    fill={activeView === "dashboard" ? "#F7CA41" : "#770C0E"}
                  />
                </svg>

                <p
                  className={`font-semibold ${
                    activeView === "dashboard"
                      ? "text-[#F7CA41]"
                      : "text-[#242424]"
                  }`}
                >
                  Dashboard
                </p>
              </button>
              <button
                onClick={() => {
                  setActiveView("citizens");
                  setSidebarOpen(true);
                }}
                className={`flex w-full cursor-pointer items-center justify-start space-x-2 rounded-lg p-2 ${
                  activeView === "citizens" ? "bg-[#003460]" : "bg-[#ffffff]"
                }`}
                title="Citizens"
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <mask
                    id="mask0_9555_1597"
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="24"
                    height="24"
                  >
                    <rect width="24" height="24" fill="#D9D9D9" />
                  </mask>
                  <g mask="url(#mask0_9555_1597)">
                    <path
                      d="M1 18C0.716667 18 0.479167 17.9042 0.2875 17.7125C0.0958333 17.5208 0 17.2833 0 17V16.425C0 15.7083 0.366667 15.125 1.1 14.675C1.83333 14.225 2.8 14 4 14C4.21667 14 4.425 14.0042 4.625 14.0125C4.825 14.0208 5.01667 14.0417 5.2 14.075C4.96667 14.425 4.79167 14.7917 4.675 15.175C4.55833 15.5583 4.5 15.9583 4.5 16.375V18H1ZM7 18C6.71667 18 6.47917 17.9042 6.2875 17.7125C6.09583 17.5208 6 17.2833 6 17V16.375C6 15.8417 6.14583 15.3542 6.4375 14.9125C6.72917 14.4708 7.14167 14.0833 7.675 13.75C8.20833 13.4167 8.84583 13.1667 9.5875 13C10.3292 12.8333 11.1333 12.75 12 12.75C12.8833 12.75 13.6958 12.8333 14.4375 13C15.1792 13.1667 15.8167 13.4167 16.35 13.75C16.8833 14.0833 17.2917 14.4708 17.575 14.9125C17.8583 15.3542 18 15.8417 18 16.375V17C18 17.2833 17.9042 17.5208 17.7125 17.7125C17.5208 17.9042 17.2833 18 17 18H7ZM19.5 18V16.375C19.5 15.9417 19.4458 15.5333 19.3375 15.15C19.2292 14.7667 19.0667 14.4083 18.85 14.075C19.0333 14.0417 19.2208 14.0208 19.4125 14.0125C19.6042 14.0042 19.8 14 20 14C21.2 14 22.1667 14.2208 22.9 14.6625C23.6333 15.1042 24 15.6917 24 16.425V17C24 17.2833 23.9042 17.5208 23.7125 17.7125C23.5208 17.9042 23.2833 18 23 18H19.5ZM4 13C3.45 13 2.97917 12.8042 2.5875 12.4125C2.19583 12.0208 2 11.55 2 11C2 10.4333 2.19583 9.95833 2.5875 9.575C2.97917 9.19167 3.45 9 4 9C4.56667 9 5.04167 9.19167 5.425 9.575C5.80833 9.95833 6 10.4333 6 11C6 11.55 5.80833 12.0208 5.425 12.4125C5.04167 12.8042 4.56667 13 4 13ZM20 13C19.45 13 18.9792 12.8042 18.5875 12.4125C18.1958 12.0208 18 11.55 18 11C18 10.4333 18.1958 9.95833 18.5875 9.575C18.9792 9.19167 19.45 9 20 9C20.5667 9 21.0417 9.19167 21.425 9.575C21.8083 9.95833 22 10.4333 22 11C22 11.55 21.8083 12.0208 21.425 12.4125C21.0417 12.8042 20.5667 13 20 13ZM12 12C11.1667 12 10.4583 11.7083 9.875 11.125C9.29167 10.5417 9 9.83333 9 9C9 8.15 9.29167 7.4375 9.875 6.8625C10.4583 6.2875 11.1667 6 12 6C12.85 6 13.5625 6.2875 14.1375 6.8625C14.7125 7.4375 15 8.15 15 9C15 9.83333 14.7125 10.5417 14.1375 11.125C13.5625 11.7083 12.85 12 12 12Z"
                      fill={activeView === "citizens" ? "#F7CA41" : "#770C0E"}
                    />
                  </g>
                </svg>
                <p
                  className={`font-semibold ${
                    activeView === "citizens"
                      ? "text-[#F7CA41]"
                      : "text-[#242424]"
                  }`}
                >
                  Survivors
                </p>
              </button>
              <button
                onClick={() => {
                  setActiveView("employees");
                  setSidebarOpen(true);
                }}
                className={`flex w-full cursor-pointer items-center justify-start space-x-2 rounded-lg p-2 ${
                  activeView === "employees" ? "bg-[#003460]" : "bg-[#ffffff]"
                }`}
                title="Employees"
              >
                <svg
                  width="24"
                  height="25"
                  viewBox="0 0 24 25"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <mask
                    id="mask0_9555_1602"
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="24"
                    height="25"
                  >
                    <rect y="0.359375" width="24" height="24" fill="#D9D9D9" />
                  </mask>
                  <g mask="url(#mask0_9555_1602)">
                    <path
                      d="M12.1002 21.0008C11.8169 21.0008 11.5794 20.9049 11.3877 20.7133C11.196 20.5216 11.1002 20.2841 11.1002 20.0008C11.1002 19.8841 11.1252 19.7633 11.1752 19.6383C11.2252 19.5133 11.3002 19.4008 11.4002 19.3008L15.6752 15.0258C15.7752 14.9258 15.8252 14.8049 15.8252 14.6633C15.8252 14.5216 15.7752 14.4008 15.6752 14.3008C15.5752 14.2008 15.4544 14.1549 15.3127 14.1633C15.171 14.1716 15.0502 14.2258 14.9502 14.3258L10.7002 18.5758C10.6002 18.6758 10.4919 18.7508 10.3752 18.8008C10.2585 18.8508 10.1335 18.8758 10.0002 18.8758C9.71686 18.8758 9.47936 18.7799 9.2877 18.5883C9.09603 18.3966 9.0002 18.1591 9.0002 17.8758C9.0002 17.7091 9.0252 17.5716 9.0752 17.4633C9.1252 17.3549 9.19186 17.2591 9.2752 17.1758L13.5502 12.9008C13.6502 12.8008 13.7002 12.6841 13.7002 12.5508C13.7002 12.4174 13.6502 12.3008 13.5502 12.2008C13.4502 12.1008 13.3335 12.0508 13.2002 12.0508C13.0669 12.0508 12.9502 12.1008 12.8502 12.2008L8.5752 16.4508C8.4752 16.5508 8.36686 16.6258 8.2502 16.6758C8.13353 16.7258 8.0002 16.7508 7.8502 16.7508C7.58353 16.7508 7.3502 16.6508 7.1502 16.4508C6.9502 16.2508 6.8502 16.0174 6.8502 15.7508C6.8502 15.6174 6.8752 15.4924 6.9252 15.3758C6.9752 15.2591 7.0502 15.1508 7.1502 15.0508L11.4002 10.8008C11.5002 10.7008 11.5502 10.5799 11.5502 10.4383C11.5502 10.2966 11.5002 10.1758 11.4002 10.0758C11.3002 9.97578 11.1835 9.92578 11.0502 9.92578C10.9169 9.92578 10.8002 9.97578 10.7002 10.0758L6.4502 14.3508C6.36686 14.4341 6.26686 14.5008 6.1502 14.5508C6.03353 14.6008 5.89186 14.6258 5.7252 14.6258C5.44186 14.6258 5.20436 14.5299 5.0127 14.3383C4.82103 14.1466 4.7252 13.9091 4.7252 13.6258C4.7252 13.4924 4.7502 13.3674 4.8002 13.2508C4.8502 13.1341 4.9252 13.0258 5.0252 12.9258L9.9252 8.02578C10.1085 7.84245 10.3377 7.75911 10.6127 7.77578C10.8877 7.79245 11.1169 7.89245 11.3002 8.07578L14.3502 11.1258C14.5335 11.3091 14.7502 11.4549 15.0002 11.5633C15.2502 11.6716 15.5002 11.7258 15.7502 11.7258C16.2835 11.7258 16.7502 11.5383 17.1502 11.1633C17.5502 10.7883 17.7502 10.3091 17.7502 9.72578C17.7502 9.49245 17.7085 9.25078 17.6252 9.00078C17.5419 8.75078 17.3919 8.51745 17.1752 8.30078L13.7502 4.87578C13.5669 4.69245 13.446 4.49245 13.3877 4.27578C13.3294 4.05911 13.3585 3.85078 13.4752 3.65078C13.6252 3.40078 13.8169 3.21745 14.0502 3.10078C14.2835 2.98411 14.5419 2.92578 14.8252 2.92578C15.1752 2.92578 15.5335 3.00911 15.9002 3.17578C16.2669 3.34245 16.6002 3.57578 16.9002 3.87578L21.1252 8.12578C21.4252 8.42578 21.646 8.75911 21.7877 9.12578C21.9294 9.49245 22.0002 9.91745 22.0002 10.4008C22.0002 10.7341 21.9252 11.0716 21.7752 11.4133C21.6252 11.7549 21.4085 12.0674 21.1252 12.3508L12.8002 20.7008C12.6669 20.8341 12.5502 20.9174 12.4502 20.9508C12.3502 20.9841 12.2335 21.0008 12.1002 21.0008ZM2.9002 12.1258C2.58353 11.8924 2.34603 11.6133 2.1877 11.2883C2.02936 10.9633 1.9502 10.6174 1.9502 10.2508C1.9502 9.86745 2.02936 9.49245 2.1877 9.12578C2.34603 8.75911 2.5752 8.42578 2.8752 8.12578L7.1002 3.87578C7.38353 3.59245 7.69603 3.37578 8.0377 3.22578C8.37936 3.07578 8.74186 3.00078 9.1252 3.00078C9.54186 3.00078 9.94603 3.07578 10.3377 3.22578C10.7294 3.37578 11.0669 3.59245 11.3502 3.87578L16.4752 9.00078C16.5585 9.08412 16.6294 9.18828 16.6877 9.31328C16.746 9.43828 16.7752 9.56745 16.7752 9.70078C16.7752 9.98411 16.6794 10.2216 16.4877 10.4133C16.296 10.6049 16.0585 10.7008 15.7752 10.7008C15.6419 10.7008 15.5127 10.6716 15.3877 10.6133C15.2627 10.5549 15.1585 10.4841 15.0752 10.4008L12.0002 7.35078C11.6169 6.96745 11.146 6.77578 10.5877 6.77578C10.0294 6.77578 9.55853 6.96745 9.1752 7.35078L4.4752 12.0508C4.25853 12.2674 4.00436 12.3799 3.7127 12.3883C3.42103 12.3966 3.1502 12.3091 2.9002 12.1258Z"
                      fill={activeView === "employees" ? "#F7CA41" : "#770C0E"}
                    />
                  </g>
                </svg>

                <p
                  className={`font-semibold ${
                    activeView === "employees"
                      ? "text-[#F7CA41]"
                      : "text-[#242424]"
                  }`}
                >
                  Employees
                </p>
              </button>
              <button
                onClick={() => {
                  setActiveView("caseManager");
                  setSidebarOpen(true);
                }}
                className={`flex w-full cursor-pointer items-center justify-start space-x-2 rounded-lg p-2 ${
                  activeView === "caseManager" ? "bg-[#003460]" : "bg-[#ffffff]"
                }`}
                title="Case Managers"
              >
                <svg
                  width="24"
                  height="25"
                  viewBox="0 0 24 25"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <mask
                    id="mask0_9767_1646"
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="24"
                    height="25"
                  >
                    <rect y="0.359375" width="24" height="24" fill="#D9D9D9" />
                  </mask>
                  <g mask="url(#mask0_9767_1646)">
                    <path
                      d="M9.46123 3.35938C7.22047 3.35938 5.40397 5.17586 5.40398 7.41662C5.40406 9.65732 7.22053 11.4737 9.46123 11.4737C11.7019 11.4737 13.5184 9.65732 13.5185 7.41662C13.5185 5.17586 11.702 3.35938 9.46123 3.35938ZM16.0872 11.1922C15.6363 11.1922 15.2733 11.6069 15.2733 12.122V13.7195H12.9819C12.6289 13.7195 12.3447 14.0035 12.3447 14.3565V20.7401C12.3447 21.0931 12.6289 21.3773 12.9819 21.3773H22.363C22.7159 21.3773 23 21.0931 23 20.7401V14.3565C23 14.0035 22.7159 13.7195 22.363 13.7195H20.164V12.122C20.164 11.6069 19.8009 11.1922 19.3499 11.1922H16.0872ZM9.92362 12.0497C9.62561 12.0497 9.26335 12.0619 8.82008 12.0914C8.22906 12.1307 7.49257 12.2018 6.8208 12.3185C6.14902 12.4352 5.55832 12.5956 5.01678 12.7694C4.47524 12.9431 3.98068 13.1306 3.49401 13.315C3.48652 13.3181 3.47911 13.3208 3.47181 13.3242L2.5629 13.7235C2.54408 13.7318 2.52586 13.7413 2.50833 13.752C2.38926 13.8247 2.23023 13.9216 2.06229 14.0788C1.89435 14.2359 1.7286 14.436 1.5869 14.665C1.4452 14.8941 1.34408 15.1294 1.25839 15.3581C1.17271 15.5868 1.08636 15.8603 1.04377 16.2245C1.00119 16.5887 0.998153 17.019 1.00063 17.3198C1.00308 17.6205 1.0137 17.8096 1.0425 17.993C1.07129 18.1763 1.12095 18.3713 1.21525 18.5643C1.30954 18.7573 1.43228 18.9211 1.56057 19.0727C1.68886 19.2243 1.84149 19.3858 2.03294 19.5271C2.22439 19.6684 2.42745 19.7702 2.6181 19.8449C2.71343 19.8823 2.86916 19.9284 3.09239 19.9516C3.31561 19.9749 3.63865 19.9899 4.20148 20.0021C5.32713 20.0263 7.40804 20.0358 8.53061 20.0422C9.65317 20.0486 9.81141 20.0545 9.97296 20.0391C10.1345 20.0238 10.3248 19.9482 10.4322 19.8711C10.5396 19.7941 10.632 19.7074 10.7171 19.6151C10.8021 19.5228 10.8936 19.4027 10.9563 19.2543C11.0189 19.1058 11.0456 18.9636 11.0624 18.8274C11.0792 18.6912 11.0927 18.5136 11.0372 18.3119C10.9816 18.1102 10.887 17.9728 10.8178 17.8652C10.7485 17.7575 10.6965 17.6799 10.6385 17.5613C10.5805 17.4427 10.5148 17.2767 10.4701 17.1038C10.4253 16.9309 10.397 16.7321 10.3897 16.5654C10.3823 16.3987 10.3937 16.2617 10.4214 16.1019C10.449 15.9421 10.4924 15.7738 10.5497 15.6205C10.607 15.4672 10.6778 15.3267 10.7824 15.1667C10.887 15.0067 11.0309 14.8227 11.1499 14.6895C11.269 14.5563 11.3715 14.4629 11.4791 14.3561C11.5867 14.2494 11.6891 14.142 11.777 14.0024C11.8649 13.8628 11.9225 13.6894 11.9413 13.5264C11.9601 13.3633 11.9588 13.1574 11.8783 12.9347C11.7979 12.7121 11.6737 12.5491 11.5462 12.4192C11.4186 12.2893 11.2071 12.1681 10.9977 12.1218C10.7882 12.0755 10.5437 12.0583 10.2009 12.0517C10.1152 12.0486 10.023 12.0486 9.92362 12.0486V12.0497ZM16.1868 12.2697H19.2105V13.7195H16.1868V12.2697ZM8.53298 19.583C9.65616 19.5894 9.8199 19.5925 9.92981 19.583C9.8199 19.5934 9.65616 19.5903 8.53298 19.583Z"
                      fill={
                        activeView === "caseManager" ? "#F7CA41" : "#770C0E"
                      }
                    />
                  </g>
                </svg>

                <p
                  className={`font-semibold ${
                    activeView === "caseManager"
                      ? "text-[#F7CA41]"
                      : "text-[#242424]"
                  }`}
                >
                  Case Managers
                </p>
              </button>
              <button
                onClick={() => {
                  setActiveView("disasters");
                  setSidebarOpen(true);
                }}
                className={`flex w-full cursor-pointer items-center justify-start space-x-2 rounded-lg p-2 ${
                  activeView === "disasters" ? "bg-[#003460]" : "bg-[#ffffff]"
                }`}
                title="Disasters"
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <mask
                    id="mask0_9555_1612"
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="24"
                    height="24"
                  >
                    <rect width="24" height="24" fill="#D9D9D9" />
                  </mask>
                  <g mask="url(#mask0_9555_1612)">
                    <path
                      d="M8.675 17.5002C7.725 17.5002 7.08333 17.3335 6.75 17.0002C6.41667 16.6668 5.95 16.5002 5.35 16.5002C4.88333 16.5002 4.50833 16.6127 4.225 16.8377C3.94167 17.0627 3.53333 17.2418 3 17.3752C2.73333 17.4418 2.5 17.3835 2.3 17.2002C2.1 17.0168 2 16.7835 2 16.5002C2 16.2168 2.1 15.971 2.3 15.7627C2.5 15.5543 2.725 15.3835 2.975 15.2502C3.25833 15.1002 3.55833 14.9377 3.875 14.7627C4.19167 14.5877 4.675 14.5002 5.325 14.5002C5.425 14.5002 5.525 14.5043 5.625 14.5127C5.725 14.521 5.81667 14.5335 5.9 14.5502L4.95 11.0502L4.175 12.0502C4.00833 12.2668 3.79167 12.396 3.525 12.4377C3.25833 12.4793 3.01667 12.4085 2.8 12.2252C2.56667 12.0418 2.4375 11.8127 2.4125 11.5377C2.3875 11.2627 2.46667 11.0168 2.65 10.8002L8.85 3.12518C9.13333 2.79184 9.48333 2.57101 9.9 2.46268C10.3167 2.35434 10.725 2.37518 11.125 2.52518L20.375 6.05018C20.625 6.15018 20.8083 6.32518 20.925 6.57518C21.0417 6.82518 21.05 7.07518 20.95 7.32518C20.85 7.59184 20.6708 7.77934 20.4125 7.88768C20.1542 7.99601 19.8917 8.00018 19.625 7.90018L18.475 7.42518L20.5 14.9502C20.6 15.0002 20.6958 15.0502 20.7875 15.1002C20.8792 15.1502 20.9667 15.2002 21.05 15.2502C21.3 15.3835 21.5208 15.5543 21.7125 15.7627C21.9042 15.971 22 16.2168 22 16.5002C22 16.7835 21.9 17.0168 21.7 17.2002C21.5 17.3835 21.2667 17.4418 21 17.3752C20.4667 17.2418 20.0667 17.0627 19.8 16.8377C19.5333 16.6127 19.1583 16.5002 18.675 16.5002C18.0417 16.5002 17.575 16.6668 17.275 17.0002C16.975 17.3335 16.3333 17.5002 15.35 17.5002C14.4 17.5002 13.7542 17.3335 13.4125 17.0002C13.0708 16.6668 12.6 16.5002 12 16.5002C11.3667 16.5002 10.9 16.6668 10.6 17.0002C10.3 17.3335 9.65833 17.5002 8.675 17.5002ZM8.675 20.0002C9.30833 20.0002 9.775 19.8335 10.075 19.5002C10.375 19.1668 11.0167 19.0002 12 19.0002C12.95 19.0002 13.5958 19.1668 13.9375 19.5002C14.2792 19.8335 14.75 20.0002 15.35 20.0002C15.9833 20.0002 16.45 19.8335 16.75 19.5002C17.05 19.1668 17.6917 19.0002 18.675 19.0002C19.325 19.0002 19.8083 19.0877 20.125 19.2627C20.4417 19.4377 20.7417 19.6002 21.025 19.7502C21.275 19.8835 21.5 20.0543 21.7 20.2627C21.9 20.471 22 20.7168 22 21.0002C22 21.2835 21.9 21.5168 21.7 21.7002C21.5 21.8835 21.2667 21.9418 21 21.8752C20.4667 21.7418 20.0667 21.5627 19.8 21.3377C19.5333 21.1127 19.1583 21.0002 18.675 21.0002C18.0583 21.0002 17.5917 21.1668 17.275 21.5002C16.9583 21.8335 16.3167 22.0002 15.35 22.0002C14.3833 22.0002 13.7375 21.8335 13.4125 21.5002C13.0875 21.1668 12.6167 21.0002 12 21.0002C11.3667 21.0002 10.9 21.1668 10.6 21.5002C10.3 21.8335 9.65833 22.0002 8.675 22.0002C7.69167 22.0002 7.05 21.8335 6.75 21.5002C6.45 21.1668 5.98333 21.0002 5.35 21.0002C4.86667 21.0002 4.49167 21.1127 4.225 21.3377C3.95833 21.5627 3.55833 21.7418 3.025 21.8752C2.75833 21.9418 2.52083 21.8835 2.3125 21.7002C2.10417 21.5168 2 21.2835 2 21.0002C2 20.7168 2.09583 20.471 2.2875 20.2627C2.47917 20.0543 2.7 19.8835 2.95 19.7502C3.23333 19.6002 3.5375 19.4377 3.8625 19.2627C4.1875 19.0877 4.68333 19.0002 5.35 19.0002C6.33333 19.0002 6.975 19.1668 7.275 19.5002C7.575 19.8335 8.04167 20.0002 8.675 20.0002ZM15.45 15.4752L14.175 10.6502C14.1417 10.5168 14.0667 10.4168 13.95 10.3502C13.8333 10.2835 13.7083 10.2668 13.575 10.3002L10.65 11.0752C10.5167 11.1085 10.4167 11.1835 10.35 11.3002C10.2833 11.4168 10.2667 11.5418 10.3 11.6752L11.1 14.6002C11.2333 14.5668 11.3708 14.5418 11.5125 14.5252C11.6542 14.5085 11.8167 14.5002 12 14.5002C12.95 14.5002 13.6292 14.6835 14.0375 15.0502C14.4458 15.4168 14.9167 15.5585 15.45 15.4752Z"
                      fill={activeView === "disasters" ? "#F7CA41" : "#770C0E"}
                    />
                  </g>
                </svg>
                <p
                  className={`font-semibold ${
                    activeView === "disasters"
                      ? "text-[#F7CA41]"
                      : "text-[#242424]"
                  }`}
                >
                  Disasters
                </p>
              </button>
            </div>
          </div>
          <div className="w-full justify-start px-4">
            <button
              onClick={handleClose}
              className="flex cursor-pointer items-center gap-2 bg-[#ffffff] font-semibold text-[#242424]"
              title="Close"
            >
              <svg
                width="16"
                height="12"
                viewBox="0 0 16 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M3.8499 7.0005L6.6999 9.8505C6.8999 10.0505 6.99574 10.2838 6.9874 10.5505C6.97907 10.8172 6.88324 11.0505 6.6999 11.2505C6.4999 11.4505 6.2624 11.5547 5.9874 11.563C5.7124 11.5713 5.4749 11.4755 5.2749 11.2755L0.699902 6.7005C0.499902 6.5005 0.399902 6.26717 0.399902 6.0005C0.399902 5.73383 0.499902 5.5005 0.699902 5.3005L5.2749 0.7255C5.4749 0.5255 5.7124 0.429667 5.9874 0.438C6.2624 0.446333 6.4999 0.5505 6.6999 0.7505C6.88324 0.9505 6.97907 1.18383 6.9874 1.4505C6.99574 1.71717 6.8999 1.9505 6.6999 2.1505L3.8499 5.0005H14.9999C15.2832 5.0005 15.5207 5.09633 15.7124 5.288C15.9041 5.47967 15.9999 5.71717 15.9999 6.0005C15.9999 6.28383 15.9041 6.52133 15.7124 6.713C15.5207 6.90467 15.2832 7.0005 14.9999 7.0005H3.8499Z"
                  fill="#242424"
                />
              </svg>
              Return to Home
            </button>
          </div>
        </div>

        {/* Filter, Sort, Group Panel */}
        {openPanel && (
          <div className="pointer-events-auto relative flex w-[300px] flex-shrink-0 flex-col border-r border-solid border-[#CFCFCF] bg-white">
            <div className="flex items-center justify-between border-b border-[#CFCFCF] px-4 pb-2 pt-4">
              <h2 className="text-[20px] font-semibold text-[#003460]">
                Advanced
              </h2>
              <button
                onClick={() => setOpenPanel(false)}
                className="bg-white text-black hover:text-gray-400"
              >
                ✕
              </button>
            </div>

            <div className="flex flex-col px-4 py-2">
              <div className="row-span-3 flex w-full items-center border-b pb-2">
                {/* Filter Button */}
                <div
                  className={`flex w-full cursor-pointer items-center justify-center space-x-1 py-2 text-sm font-semibold ${
                    activePanel === "filter"
                      ? "border-b-2 border-solid border-[#003460] text-[#003460]"
                      : "border-b border-solid border-[#525252] text-[#525252]"
                  }`}
                  onClick={() => setActivePanel("filter")}
                >
                  <svg
                    width="17"
                    height="16"
                    viewBox="0 0 17 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-5 w-5"
                  >
                    <path
                      d="M7.16668 16C6.88334 16 6.64584 15.9042 6.45418 15.7125C6.26251 15.5208 6.16668 15.2833 6.16668 15V9L0.366676 1.6C0.116676 1.26667 0.0791759 0.916667 0.254176 0.55C0.429176 0.183333 0.733343 0 1.16668 0H15.1667C15.6 0 15.9042 0.183333 16.0792 0.55C16.2542 0.916667 16.2167 1.26667 15.9667 1.6L10.1667 9V15C10.1667 15.2833 10.0708 15.5208 9.87918 15.7125C9.68751 15.9042 9.45001 16 9.16668 16H7.16668Z"
                      fill={activePanel === "filter" ? "#003460" : "#525252"}
                    />
                  </svg>

                  <span>Filter</span>
                </div>

                {/* Sort Button */}
                <div
                  className={`flex w-full cursor-pointer items-center justify-center space-x-1 py-2 text-sm font-semibold ${
                    activePanel === "sort"
                      ? "border-b-2 border-solid border-[#003460] text-[#003460]"
                      : "border-b border-solid border-[#525252] text-[#525252]"
                  }`}
                  onClick={() => setActivePanel("sort")}
                >
                  <svg
                    width="18"
                    height="12"
                    viewBox="0 0 18 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-5 w-5"
                  >
                    <path
                      d="M1 12C0.716667 12 0.479167 11.9042 0.2875 11.7125C0.0958333 11.5208 0 11.2833 0 11C0 10.7167 0.0958333 10.4792 0.2875 10.2875C0.479167 10.0958 0.716667 10 1 10H5C5.28333 10 5.52083 10.0958 5.7125 10.2875C5.90417 10.4792 6 10.7167 6 11C6 11.2833 5.90417 11.5208 5.7125 11.7125C5.52083 11.9042 5.28333 12 5 12H1ZM1 7C0.716667 7 0.479167 6.90417 0.2875 6.7125C0.0958333 6.52083 0 6.28333 0 6C0 5.71667 0.0958333 5.47917 0.2875 5.2875C0.479167 5.09583 0.716667 5 1 5H11C11.2833 5 11.5208 5.09583 11.7125 5.2875C11.9042 5.47917 12 5.71667 12 6C12 6.28333 11.9042 6.52083 11.7125 6.7125C11.5208 6.90417 11.2833 7 11 7H1ZM1 2C0.716667 2 0.479167 1.90417 0.2875 1.7125C0.0958333 1.52083 0 1.28333 0 1C0 0.716667 0.0958333 0.479167 0.2875 0.2875C0.479167 0.0958333 0.716667 0 1 0H17C17.2833 0 17.5208 0.0958333 17.7125 0.2875C17.9042 0.479167 18 0.716667 18 1C18 1.28333 17.9042 1.52083 17.7125 1.7125C17.5208 1.90417 17.2833 2 17 2H1Z"
                      fill={activePanel === "sort" ? "#003460" : "#525252"}
                    />
                  </svg>

                  <span>Sort</span>
                </div>

                {/* Group Button */}
                <div
                  className={`flex w-full cursor-pointer items-center justify-center space-x-1 py-2 text-sm font-semibold ${
                    activePanel === "group"
                      ? "border-b-2 border-solid border-[#003460] text-[#003460]"
                      : "border-b border-solid border-[#525252] text-[#525252]"
                  }`}
                  onClick={() => setActivePanel("group")}
                >
                  <svg
                    width="21"
                    height="20"
                    viewBox="0 0 21 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-5 w-5"
                  >
                    <path
                      d="M7.33331 14C7.88331 14 8.35415 13.8042 8.74581 13.4125C9.13748 13.0208 9.33331 12.55 9.33331 12C9.33331 11.45 9.13748 10.9792 8.74581 10.5875C8.35415 10.1958 7.88331 10 7.33331 10C6.78331 10 6.31248 10.1958 5.92081 10.5875C5.52915 10.9792 5.33331 11.45 5.33331 12C5.33331 12.55 5.52915 13.0208 5.92081 13.4125C6.31248 13.8042 6.78331 14 7.33331 14ZM13.3333 14C13.8833 14 14.3541 13.8042 14.7458 13.4125C15.1375 13.0208 15.3333 12.55 15.3333 12C15.3333 11.45 15.1375 10.9792 14.7458 10.5875C14.3541 10.1958 13.8833 10 13.3333 10C12.7833 10 12.3125 10.1958 11.9208 10.5875C11.5291 10.9792 11.3333 11.45 11.3333 12C11.3333 12.55 11.5291 13.0208 11.9208 13.4125C12.3125 13.8042 12.7833 14 13.3333 14ZM10.3333 9C10.8833 9 11.3541 8.80417 11.7458 8.4125C12.1375 8.02083 12.3333 7.55 12.3333 7C12.3333 6.45 12.1375 5.97917 11.7458 5.5875C11.3541 5.19583 10.8833 5 10.3333 5C9.78331 5 9.31248 5.19583 8.92081 5.5875C8.52915 5.97917 8.33331 6.45 8.33331 7C8.33331 7.55 8.52915 8.02083 8.92081 8.4125C9.31248 8.80417 9.78331 9 10.3333 9ZM10.3333 20C8.94998 20 7.64998 19.7375 6.43331 19.2125C5.21665 18.6875 4.15831 17.975 3.25831 17.075C2.35831 16.175 1.64581 15.1167 1.12081 13.9C0.595813 12.6833 0.333313 11.3833 0.333313 10C0.333313 8.61667 0.595813 7.31667 1.12081 6.1C1.64581 4.88333 2.35831 3.825 3.25831 2.925C4.15831 2.025 5.21665 1.3125 6.43331 0.7875C7.64998 0.2625 8.94998 0 10.3333 0C11.7166 0 13.0166 0.2625 14.2333 0.7875C15.45 1.3125 16.5083 2.025 17.4083 2.925C18.3083 3.825 19.0208 4.88333 19.5458 6.1C20.0708 7.31667 20.3333 8.61667 20.3333 10C20.3333 11.3833 20.0708 12.6833 19.5458 13.9C19.0208 15.1167 18.3083 16.175 17.4083 17.075C16.5083 17.975 15.45 18.6875 14.2333 19.2125C13.0166 19.7375 11.7166 20 10.3333 20Z"
                      fill={activePanel === "group" ? "#003460" : "#525252"}
                    />
                  </svg>

                  <span>Group</span>
                </div>
              </div>

              {activePanel === "filter" && (
                <div className="space-y-2">
                  {/* Disaster Section */}
                  <div className="border-b pb-2">
                    <div className="flex flex-col">
                      <p className="mb-2 text-sm font-semibold">Disaster</p>
                      <div className="relative">
                        <select
                          className="w-full appearance-none rounded border border-gray-300 bg-white px-3 py-2 pr-8 text-sm focus:border-[#467BA4] focus:outline-none"
                          value={
                            tempSelectedDisasters || selectedDisaster || ""
                          } // Added empty string fallback
                          onChange={(e) => {
                            setTempSelectedDisasters(e.target.value);
                          }}
                        >
                          <option value="">Select Disaster</option>{" "}
                          {/* Added default option */}
                          {disasterOptions.map((disaster) => (
                            <option key={disaster.id} value={disaster.id}>
                              {disaster.name}
                            </option>
                          ))}
                        </select>
                        <div className="text-gray-700 pointer-events-none absolute inset-y-0 right-0 flex items-center px-2">
                          <FaChevronDown className="h-4 w-4" />
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Homeowner Section */}
                  <div className="border-b pb-2">
                    <div
                      className="flex cursor-pointer items-center justify-between"
                      onClick={() => setShowHomeowner(!showHomeowner)}
                    >
                      <p className="text-sm">Homeowner or Renter</p>
                      {showHomeowner ? <FaChevronUp /> : <FaChevronDown />}
                    </div>
                    {showHomeowner && (
                      <div className="mt-2 space-y-1">
                        <label className="block cursor-pointer text-sm">
                          <input type="checkbox" className="mr-2 h-4 w-4" />
                          Homeowners
                        </label>
                        <label className="block cursor-pointer text-sm">
                          <input type="checkbox" className="mr-2 h-4 w-4" />
                          Renter
                        </label>
                        <label className="block cursor-pointer text-sm">
                          <input type="checkbox" className="mr-2 h-4 w-4" />
                          Rent to Own
                        </label>
                      </div>
                    )}
                  </div>

                  {/* Damage Impact Section */}
                  <div className="border-b pb-2">
                    <div
                      className="flex cursor-pointer items-center justify-between"
                      onClick={() => setShowDamage(!showDamage)}
                    >
                      <p className="text-sm">Damage Impact</p>
                      {showDamage ? <FaChevronUp /> : <FaChevronDown />}
                    </div>
                    {showDamage && (
                      <div className="mt-2 space-y-1">
                        {damageOptions.map((damage) => (
                          <label
                            key={damage}
                            className="block cursor-pointer text-sm"
                          >
                            <input type="checkbox" className="mr-2 h-4 w-4" />
                            {damage}
                          </label>
                        ))}
                      </div>
                    )}
                  </div>

                  {/* Status Section */}
                  <div className="border-b pb-2">
                    <div
                      className="flex cursor-pointer items-center justify-between"
                      onClick={() => setShowStatus(!showStatus)}
                    >
                      <p className="text-sm">Status</p>
                      {showStatus ? <FaChevronUp /> : <FaChevronDown />}
                    </div>
                    {showStatus && (
                      <div className="mt-2 space-y-1">
                        <label className="block cursor-pointer text-sm">
                          <input
                            type="checkbox"
                            className="mr-2 h-4 w-4"
                            checked={tempSelectedStatus.Open}
                            onChange={(e) =>
                              setTempSelectedStatus((prev) => ({
                                ...prev,
                                Open: e.target.checked,
                              }))
                            }
                          />
                          Open Cases
                        </label>
                        <label className="block cursor-pointer text-sm">
                          <input
                            type="checkbox"
                            className="mr-2 h-4 w-4"
                            checked={tempSelectedStatus.Closed}
                            onChange={(e) =>
                              setTempSelectedStatus((prev) => ({
                                ...prev,
                                Closed: e.target.checked,
                              }))
                            }
                          />
                          Closed Cases
                        </label>
                        <label className="block cursor-pointer text-sm">
                          <input
                            type="checkbox"
                            className="mr-2 h-4 w-4"
                            checked={tempSelectedStatus.Unassigned}
                            onChange={(e) =>
                              setTempSelectedStatus((prev) => ({
                                ...prev,
                                Unassigned: e.target.checked,
                              }))
                            }
                          />
                          Unassigned Cases
                        </label>
                      </div>
                    )}
                  </div>
                </div>
              )}
              {activePanel === "sort" && (
                <div className="space-y-2">
                  {/* <p className="mb-2 text-sm font-semibold">Sort By</p> */}
                  <div className="space-y-2">
                    {sortOptions.map((option) => (
                      <label
                        key={option}
                        className="block cursor-pointer text-sm"
                      >
                        <input
                          type="radio"
                          name="sort"
                          className="mr-2 h-4 w-4"
                          checked={tempSelectedSort === option}
                          onChange={() => setTempSelectedSort(option)}
                        />
                        {option}
                      </label>
                    ))}
                  </div>
                </div>
              )}
              {activePanel === "group" && (
                <div className="space-y-2">
                  <p className="mb-2 text-sm font-semibold">Group By</p>
                  <p className="text-sm text-gray-500">
                    Placeholder for Grouping options...
                  </p>
                </div>
              )}
            </div>

            <div className="mt-auto border-t p-4">
              <button className="w-full rounded bg-[#003460] py-3 text-[#F7CA41] hover:bg-[#003460]">
                Apply Filter
              </button>
            </div>
          </div>
        )}

        {/* Expandable Sidebar Panel */}
        <div
          className={`absolute left-[246px] h-screen w-80 overflow-y-auto bg-gray-200 shadow-lg transition-all duration-300 ease-in-out 
      ${
        sidebarOpen
          ? "pointer-events-auto translate-x-0"
          : "pointer-events-none -translate-x-full"
      }`}
        >
          <div className="h-full bg-[#FAFAFA]">
            <div className="flex items-center justify-between border-b px-4 py-2">
              <h2 className="text-base font-semibold text-[#003460]">
                {activeView === "partners"
                  ? "Partners"
                  : activeView === "citizens"
                  ? "Survivors"
                  : activeView === "caseManager"
                  ? "Case Managers"
                  : activeView === "disasters"
                  ? "Disasters"
                  : activeView === "employees"
                  ? "Employees"
                  : ""}
              </h2>
              <button
                onClick={() => setSidebarOpen(false)}
                className="hover:bg-gray-100 bg-white p-2 hover:cursor-pointer"
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <mask
                    id="mask0_9552_3351"
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="24"
                    height="24"
                  >
                    <rect width="24" height="24" fill="#D9D9D9" />
                  </mask>
                  <g mask="url(#mask0_9552_3351)">
                    <path
                      d="M11.9998 13.4008L7.0998 18.3008C6.91647 18.4841 6.68314 18.5758 6.3998 18.5758C6.11647 18.5758 5.88314 18.4841 5.6998 18.3008C5.51647 18.1174 5.4248 17.8841 5.4248 17.6008C5.4248 17.3174 5.51647 17.0841 5.6998 16.9008L10.5998 12.0008L5.6998 7.10078C5.51647 6.91745 5.4248 6.68411 5.4248 6.40078C5.4248 6.11745 5.51647 5.88411 5.6998 5.70078C5.88314 5.51745 6.11647 5.42578 6.3998 5.42578C6.68314 5.42578 6.91647 5.51745 7.0998 5.70078L11.9998 10.6008L16.8998 5.70078C17.0831 5.51745 17.3165 5.42578 17.5998 5.42578C17.8831 5.42578 18.1165 5.51745 18.2998 5.70078C18.4831 5.88411 18.5748 6.11745 18.5748 6.40078C18.5748 6.68411 18.4831 6.91745 18.2998 7.10078L13.3998 12.0008L18.2998 16.9008C18.4831 17.0841 18.5748 17.3174 18.5748 17.6008C18.5748 17.8841 18.4831 18.1174 18.2998 18.3008C18.1165 18.4841 17.8831 18.5758 17.5998 18.5758C17.3165 18.5758 17.0831 18.4841 16.8998 18.3008L11.9998 13.4008Z"
                      fill="#8F8F8F"
                    />
                  </g>
                </svg>
              </button>
            </div>
            {renderSidebarContent()}
          </div>
        </div>
      </div>
      <div
        className={`ml-[246px] max-h-[calc(100vh-6vh)] flex-1 overflow-y-auto overflow-x-hidden`}
      >
        {activeView === "dashboard" && (
          <div>
            <CaseManagementDashboard></CaseManagementDashboard>
          </div>
        )}
        {activeView !== "dashboard" && (
          <div className="px-6 py-4">
            <div className="relative">
              {/* Add close button container */}

              <div className="max-w-[calc(100%)] px-6">
                <div
                  className="relative mb-4 flex items-center gap-2 pt-4"
                  ref={dropdownRef}
                >
                  {/* Left side - Disasters dropdown */}
                  {/* <div className="flex flex-grow items-center">
                  <span className="text-sm font-bold text-red-500">
                    DISASTERS
                  </span>
                  <div className="relative flex w-full items-center justify-between">
                    <div className="relative">
                      <button
                        onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                        className="relative flex w-[450px] items-center justify-between rounded border border-dodgerblue px-4 py-1 text-sm"
                      >
                        <span className="absolute inset-0 flex items-center justify-center">
                          <span className="truncate px-6">
                            {selectedDisasters.length > 0
                              ? disasterOptions.find(
                                  (disaster) =>
                                    disaster.id === selectedDisasters[0]
                                )?.name
                              : "Select a Disaster"}
                          </span>
                        </span>
                        <span className="ml-auto">▼</span>
                      </button>
                      {isDropdownOpen && (
                        <div className="absolute left-0 right-0 z-10 mt-1 rounded border border-gray-300 bg-white shadow-lg">

                          <div className="border-b border-gray-200 p-2">
                            <label className="text-gray-600 flex cursor-pointer items-center text-sm">
                              <input
                                type="checkbox"
                                checked={showInactive}
                                onChange={(e) =>
                                  setShowInactive(e.target.checked)
                                }
                                className="mr-2"
                              />
                              Show Inactive/Closed Disasters
                            </label>
                          </div>
           
                          <div className="max-h-60 overflow-y-auto">
                            {disasterOptions
                              .filter((disaster) =>
                                showInactive
                                  ? true
                                  : disaster.status === "active"
                              )
                              .map((disaster) => (
                                <div
                                  key={disaster.id}
                                  className={`hover:bg-gray-100 flex cursor-pointer items-center justify-between px-4 py-2 text-center ${
                                    disaster.status === "closed"
                                      ? "opacity-50"
                                      : ""
                                  }`}
                                  onClick={() => {
                                    setSelectedDisasters([disaster.id]);
                                    setIsDropdownOpen(false);
                                  }}
                                >
                                  <span>{disaster.name}</span>
                                  {disaster.status !== "active" && (
                                    <span
                                      className={`ml-2 text-xs ${
                                        disaster.status === "inactive"
                                          ? "text-gray-500"
                                          : "text-red-500"
                                      }`}
                                    >
                                      (
                                      {disaster.status === "inactive"
                                        ? "Inactive"
                                        : "Closed"}
                                      )
                                    </span>
                                  )}
                                </div>
                              ))}
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div> */}

                  {/* Sort by */}
                  {/* <div className="relative inline-block text-left">
                  <button
                    className="text-gray-700 hover:bg-gray-50 flex min-w-[300px] items-center justify-between gap-2 rounded-md border border-gray-300 bg-white px-5 py-3 text-sm shadow-sm focus:outline-none"
                    onClick={toggleDropdown}
                  >
                    <span>{selectedOption || "Sort by"}</span>
                    <FaChevronDown
                      className={`text-xs transition-transform duration-200 ${
                        dropdownOpen ? "rotate-180" : ""
                      }`}
                    />
                  </button>

                  {dropdownOpen && (
                    <div className="absolute right-0 z-20 mt-1 w-full space-y-3 rounded-md border border-gray-200 bg-white p-4 shadow-lg">
                      {options.map((option, index) => (
                        <p
                          onClick={() => handleOptionClick(option)}
                          className={`text-gray-700 block cursor-pointer px-4 py-2 text-sm ${
                            selectedOption === option
                              ? "bg-[#DAEBF9]"
                              : "hover:bg-[#DAEBF9]"
                          }`}
                          role="menuitem"
                        >
                          {option}
                        </p>
                      ))}
                    </div>
                  )}
                </div> */}
                  <div className="mb-1 flex w-full gap-2">
                    <button
                      className="flex items-center gap-2 rounded border border-solid border-[#003460] bg-white px-5 py-4 text-[#003460] hover:text-[#2563EB]"
                      onClick={() => togglePanel()}
                    >
                      <svg
                        width="20"
                        height="13"
                        viewBox="0 0 20 13"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M1 13C0.716667 13 0.479167 12.9042 0.2875 12.7125C0.0958333 12.5208 0 12.2833 0 12C0 11.7167 0.0958333 11.4792 0.2875 11.2875C0.479167 11.0958 0.716667 11 1 11H9C9.28333 11 9.52083 11.0958 9.7125 11.2875C9.90417 11.4792 10 11.7167 10 12C10 12.2833 9.90417 12.5208 9.7125 12.7125C9.52083 12.9042 9.28333 13 9 13H1ZM1 8C0.716667 8 0.479167 7.90417 0.2875 7.7125C0.0958333 7.52083 0 7.28333 0 7C0 6.71667 0.0958333 6.47917 0.2875 6.2875C0.479167 6.09583 0.716667 6 1 6H4C4.28333 6 4.52083 6.09583 4.7125 6.2875C4.90417 6.47917 5 6.71667 5 7C5 7.28333 4.90417 7.52083 4.7125 7.7125C4.52083 7.90417 4.28333 8 4 8H1ZM1 3C0.716667 3 0.479167 2.90417 0.2875 2.7125C0.0958333 2.52083 0 2.28333 0 2C0 1.71667 0.0958333 1.47917 0.2875 1.2875C0.479167 1.09583 0.716667 1 1 1H4C4.28333 1 4.52083 1.09583 4.7125 1.2875C4.90417 1.47917 5 1.71667 5 2C5 2.28333 4.90417 2.52083 4.7125 2.7125C4.52083 2.90417 4.28333 3 4 3H1ZM12 10C10.6167 10 9.4375 9.5125 8.4625 8.5375C7.4875 7.5625 7 6.38333 7 5C7 3.61667 7.4875 2.4375 8.4625 1.4625C9.4375 0.4875 10.6167 0 12 0C13.3833 0 14.5625 0.4875 15.5375 1.4625C16.5125 2.4375 17 3.61667 17 5C17 5.48333 16.9292 5.9625 16.7875 6.4375C16.6458 6.9125 16.4333 7.35 16.15 7.75L19.3 10.9C19.4833 11.0833 19.575 11.3167 19.575 11.6C19.575 11.8833 19.4833 12.1167 19.3 12.3C19.1167 12.4833 18.8833 12.575 18.6 12.575C18.3167 12.575 18.0833 12.4833 17.9 12.3L14.75 9.15C14.35 9.43333 13.9125 9.64583 13.4375 9.7875C12.9625 9.92917 12.4833 10 12 10ZM12 8C12.8333 8 13.5417 7.70833 14.125 7.125C14.7083 6.54167 15 5.83333 15 5C15 4.16667 14.7083 3.45833 14.125 2.875C13.5417 2.29167 12.8333 2 12 2C11.1667 2 10.4583 2.29167 9.875 2.875C9.29167 3.45833 9 4.16667 9 5C9 5.83333 9.29167 6.54167 9.875 7.125C10.4583 7.70833 11.1667 8 12 8Z"
                          fill="#003460"
                        />
                      </svg>

                      <span className="text-lg text-[#003460] ">Advanced</span>
                    </button>
                  </div>
                </div>
                <div className="relative">
                  <GridComponent
                    ref={gridRef}
                    dataSource={gridData}
                    allowSorting={true}
                    allowGrouping={true} // Enable grouping
                    groupSettings={{
                      showGroupedColumn: true,
                      showDropArea: true,
                      expandAll: false,
                      captionTemplate:
                        employeeRole === "Case Manager"
                          ? null
                          : groupCaptionTemplate,
                    }}
                    sortSettings={sortSettings}
                    editSettings={editSettings}
                    filterSettings={filterSettings}
                    allowFiltering={true}
                    // Add GroupingBar to toolbar
                    allowPaging={true}
                    pageSettings={pageSettings}
                    showColumnMenu={true}
                    columnMenuItems={columnMenuItems}
                    commandClick={handleCommandClick}
                    selectionSettings={{
                      type: "Multiple",
                      mode: "Row",
                      checkboxOnly: true,
                      persistSelection: true, // Add this to maintain selection state
                    }}
                    cssClass="casemanagement-grid"
                    rowSelected={selectionHandler}
                    rowDeselected={selectionHandler}
                  >
                    <ColumnsDirective>
                      <ColumnDirective
                        field="id"
                        isPrimaryKey
                        visible={false}
                      />
                      <ColumnDirective field="citizen_id" visible={false} />
                      <ColumnDirective
                        type="checkbox"
                        width="50"
                        allowGrouping={false}
                      />
                      <ColumnDirective
                        field="state"
                        headerText="State"
                        width="100"
                        allowGrouping={true}
                      />
                      <ColumnDirective
                        field="county"
                        headerText="County"
                        width="100"
                        allowGrouping={true}
                        template={(props) => (
                          <div className="text-sm">
                            {props.county || "Unspecified"}
                          </div>
                        )}
                        groupCaptionTemplate={(props) => (
                          <div>County: {props.key || "Unspecified"}</div>
                        )}
                      />
                      <ColumnDirective
                        field="name"
                        headerText="Case Details"
                        width="300"
                        allowGrouping={true}
                        template={(props) => (
                          <div className="py-2">
                            <div className="grid grid-cols-2 gap-x-4 gap-y-1">
                              <div className="font-semibold">Name</div>
                              <div>{props.name}</div>

                              <div className="font-semibold">Case #</div>
                              <div>{props.case_number}</div>

                              <div className="font-semibold">
                                Impacted Address
                              </div>
                              <div>{props.address}</div>
                            </div>
                          </div>
                        )}
                      />
                      <ColumnDirective
                        field="assigned_to_case_manager" // Updated field name
                        headerText="Assignment Details"
                        width="300"
                        allowGrouping={true}
                        template={(props) => (
                          <div className="py-2">
                            <div className="grid grid-cols-2 gap-x-4 gap-y-1">
                              <div className="font-semibold">Case Manager</div>
                              <div>
                                {props.assigned_to_case_manager || "Unassigned"}
                              </div>

                              <div className="font-semibold">Organization</div>
                              <div>{props.assigned_to_org || "Unassigned"}</div>

                              <div className="font-semibold">Date Assigned</div>
                              <div>
                                {props.assignment_date
                                  ? new Date(
                                      props.assignment_date
                                    ).toLocaleDateString("en-US", {
                                      year: "numeric",
                                      month: "short",
                                      day: "numeric",
                                      hour: "2-digit",
                                      minute: "2-digit",
                                    })
                                  : "-"}
                              </div>
                            </div>
                          </div>
                        )}
                        groupCaptionTemplate={(props) => (
                          <div>
                            {props.field === "assigned_to_case_manager"
                              ? `Case Manager: ${props.key || "Unassigned"}`
                              : props.key}
                          </div>
                        )}
                      />

                      <ColumnDirective
                        field="status"
                        headerText="Status"
                        width="200"
                        allowGrouping={true}
                        template={(props) => {
                          const statusColor =
                            props.status === "Open"
                              ? "bg-green-100 text-green-800"
                              : "bg-red-100 text-red-800";

                          const formatDate = (dateString) => {
                            if (!dateString) return "";
                            return new Date(dateString).toLocaleDateString(
                              "en-US",
                              {
                                year: "numeric",
                                month: "short",
                                day: "numeric",
                              }
                            );
                          };

                          return (
                            <div className="py-2">
                              {/* Status section remains the same */}
                              <div className="mb-1 flex flex-col items-center gap-1">
                                <div
                                  className={`inline-flex items-center gap-1 rounded-full px-5 py-1.5 text-xs font-medium ${
                                    props.status === "Open"
                                      ? "bg-[#56C33B] text-white"
                                      : props.status === "Closed"
                                      ? "bg-[#525252] text-white"
                                      : "bg-[#606060] text-white"
                                  }`}
                                >
                                  <img
                                    src={
                                      props.status === "Open"
                                        ? StatusClosedIcon
                                        : StatusOpenIcon
                                    }
                                    alt=""
                                    className="h-4 w-4"
                                  />
                                  {props.status || "Unassigned"}
                                </div>
                              </div>

                              {/* Actions section with updated colors */}
                              <div className="mt-1 flex justify-center gap-2 border-t pt-3">
                                <button
                                  onClick={() =>
                                    handleCommandClick({
                                      commandColumn: { type: "View" },
                                      rowData: props,
                                    })
                                  }
                                  className="group relative flex items-center gap-1 bg-[#0A8525] px-2 py-2 text-xs font-medium text-white transition-colors hover:bg-[#084D16]"
                                >
                                  <img
                                    src={RecoveryPlanIcon}
                                    alt=""
                                    className="icon-recovery-tracker h-5 w-5"
                                  />
                                  <span className="absolute -top-8 left-1/2 -translate-x-1/2 whitespace-nowrap rounded bg-gray-800 px-2 py-1 text-xs text-white opacity-0 transition-opacity group-hover:opacity-100">
                                    View Recovery
                                  </span>
                                </button>

                                {employeeRole !== "Case Manager" && (
                                  <button
                                    onClick={() =>
                                      handleCommandClick({
                                        commandColumn: { type: "Assign" },
                                        rowData: props,
                                      })
                                    }
                                    className={`group relative flex items-center gap-1 px-3 py-1.5 text-xs font-medium text-white transition-colors ${
                                      props.assigned_to_case_manager_uid
                                        ? "bg-[#606060] hover:bg-[#404040]"
                                        : "bg-[#22B0ED] hover:bg-[#1A8BB9]"
                                    }`}
                                  >
                                    <img
                                      src={
                                        props.assigned_to_case_manager_uid
                                          ? ReassignIcon
                                          : AssignIcon
                                      }
                                      alt=""
                                      className={`h-4 w-4 ${
                                        props.assigned_to_case_manager_uid
                                          ? "icon-reassign"
                                          : "icon-assign"
                                      }`}
                                    />
                                    <span className="absolute -top-8 left-1/2 -translate-x-1/2 whitespace-nowrap rounded bg-gray-800 px-2 py-1 text-xs text-white opacity-0 transition-opacity group-hover:opacity-100">
                                      {props.assigned_to_case_manager_uid
                                        ? "Reassign"
                                        : "Assign"}
                                    </span>
                                  </button>
                                )}

                                <button
                                  onClick={() =>
                                    handleCommandClick({
                                      commandColumn: { type: "Access" },
                                      rowData: props,
                                    })
                                  }
                                  className="group relative flex items-center gap-1 bg-[#FB931D] px-3 py-1.5 text-xs font-medium text-white transition-colors hover:bg-[#D97B13]"
                                >
                                  <img
                                    src={AccessAccountIcon}
                                    alt=""
                                    className="icon-access-account h-4 w-4"
                                  />
                                  <span className="absolute -top-8 left-1/2 -translate-x-1/2 whitespace-nowrap rounded bg-gray-800 px-2 py-1 text-xs text-white opacity-0 transition-opacity group-hover:opacity-100">
                                    Access Account
                                  </span>
                                </button>
                              </div>
                            </div>
                          );
                        }}
                      />
                      {/* <ColumnDirective
                            headerText="Actions"
                            textAlign="Center"
                            width="500"
                            allowGrouping={false} // Disable grouping for actions column
                            headerTemplate={() => (
                              <div className="font-semibold text-gray-700">Actions</div>
                            )}
                            template={(props) => (
                              <div className="flex gap-2 justify-center">
                                <button
                                  onClick={() => handleCommandClick({ commandColumn: { type: "View" }, rowData: props })}
                                  className="px-3 py-1 text-xs font-medium text-blue-600 hover:text-blue-800 border border-blue-600 hover:border-blue-800 rounded-full"
                                >
                                  View Recovery Plan
                                </button>
                                
                                {employeeRole !== "Navigator" && (
                                  <>
                                    <button
                                      onClick={() => handleCommandClick({ commandColumn: { type: "Assign" }, rowData: props })}
                                      className={`px-3 py-1 text-xs font-medium rounded-full ${
                                        props.assigned_to 
                                          ? "text-orange-600 hover:text-orange-800 border border-orange-600 hover:border-orange-800"
                                          : "text-green-600 hover:text-green-800 border border-green-600 hover:border-green-800"
                                      }`}
                                    >
                                      {props.assigned_to ? "Reassign" : "Assign"}
                                    </button>
                                    
                                  </>
                                )}
                                <button
                                      onClick={() => handleCommandClick({ commandColumn: { type: "Access" }, rowData: props })}
                                      className="px-3 py-1 text-xs font-medium text-gray-600 hover:text-gray-800 border border-gray-600 hover:border-gray-800 rounded-full"
                                    >
                                      Access Account
                                    </button>
                              </div>
                            )}
                          /> */}
                    </ColumnsDirective>
                    <Inject
                      services={[
                        Page,
                        Sort,
                        Filter,
                        Search,
                        ColumnMenu,
                        Group,
                        Toolbar,
                        Selection,
                      ]}
                    />
                  </GridComponent>
                </div>

                <DialogComponent
                  width="500px"
                  isModal={true}
                  visible={assignDialogOpen}
                  close={handleDialogClose}
                  header={`${
                    selectedCase?.assigned_to_case_manager
                      ? "Reassign"
                      : "Assign"
                  } Case`}
                  showCloseIcon={true}
                  closeOnEscape={true}
                  target="#root"
                >
                  <div className="px-3 pb-1 pt-4">
                    {/* Name and Case Number */}
                    <h2 className="mb-4 text-xl font-medium">
                      {selectedCase?.name}
                    </h2>
                    <div className="mb-3 flex items-center gap-2 text-base">
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="#22B0ED"
                      >
                        <path
                          d="M6 2V14M10 2V14M2 6H14M2 10H14"
                          stroke="#22B0ED"
                          strokeWidth="2"
                          strokeLinecap="round"
                        />
                      </svg>
                      <div>
                        <span>Case No.</span>
                        <span className="font-medium">
                          {" "}
                          {selectedCase?.case_number}
                        </span>
                      </div>
                    </div>

                    {/* Location Details */}
                    <div className="mb-6">
                      <div className="mb-2 flex items-center gap-2 text-base">
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="#22B0ED"
                        >
                          <path d="M8 0C4.1 0 1 3.1 1 7c0 5.2 7 9 7 9s7-3.8 7-9c0-3.9-3.1-7-7-7zm0 9.5c-1.4 0-2.5-1.1-2.5-2.5S6.6 4.5 8 4.5s2.5 1.1 2.5 2.5S9.4 9.5 8 9.5z" />
                        </svg>
                        <span className="">Location Details:</span>
                      </div>
                      <div className="text-sm">
                        <div className="mb-1.5">
                          <span className="text-base">Address: </span>
                          <span className="font-medium">
                            {selectedCase?.address}
                          </span>
                        </div>
                        <div>
                          <span className="text-base">County: </span>
                          <span className="font-medium">
                            {selectedCase?.county}
                          </span>
                        </div>
                      </div>
                    </div>

                    {/* Unassign Checkbox */}
                    {/* Assign To Section with Unassign Checkbox */}
                    <div className="mb-4">
                      <div className="mb-2 flex items-center justify-between">
                        <label className="block">Assign To</label>
                      </div>

                      {/* Dropdown - Only show if not unassigning */}
                      {assignmentType !== "Unassign" && (
                        <DropDownListComponent
                          dataSource={[
                            ...employees
                              .filter((emp) => !emp.is_admin)
                              .map((emp) => ({
                                value: emp.id,
                                text: emp.fullName,
                                type: "Case Manager",
                                role: emp.role,
                                data: emp,
                              })),
                          ]}
                          fields={{
                            text: "text",
                            value: "value",
                          }}
                          placeholder="Select Assignee"
                          value={dropdownValue}
                          itemTemplate={(props) => (
                            <div className="flex w-full items-center justify-between">
                              <span>{props.text}</span>
                              <span className="text-xs text-gray-500">
                                {props.role}
                              </span>
                            </div>
                          )}
                          change={(args) => {
                            if (!args.itemData) return;
                            setDropdownValue(args.itemData.value);
                            setSelectedEmployee(args.itemData.data);
                          }}
                        />
                      )}
                    </div>

                    {/* Future Assignments Checkbox - Only show if not unassigning */}
                    {assignmentType !== "Unassign" &&
                      selectedCase?.groupInfo && (
                        <div className="mb-4">
                          <label className="text-gray-600 flex items-center gap-2 text-sm">
                            <input
                              type="checkbox"
                              className="form-checkbox h-4 w-4 text-blue-600"
                              checked={applyToFutureGroup}
                              onChange={(e) =>
                                setApplyToFutureGroup(e.target.checked)
                              }
                            />
                            <span>
                              Assign{" "}
                              {selectedEmployee?.fullName ||
                                selectedCompany?.name_of_org}{" "}
                              to all {selectedCase.groupInfo.field} cases in{" "}
                              {selectedCase.groupInfo.value} in the future
                            </span>
                          </label>
                        </div>
                      )}
                    <div className="mb-6">
                      <label className="flex items-center gap-2 text-sm">
                        <input
                          type="checkbox"
                          className="h-4 w-4 rounded border-gray-300"
                          checked={assignmentType === "Unassign"}
                          onChange={(e) => {
                            if (e.target.checked) {
                              setAssignmentType("Unassign");
                              setSelectedEmployee(null);
                              setSelectedCompany(null);
                            } else {
                              setAssignmentType("Case Manager");
                            }
                          }}
                        />
                        <span>Unassign this case</span>
                      </label>
                    </div>
                    {/* Action Buttons */}
                    <div className="flex justify-end gap-2">
                      <button
                        onClick={handleDialogClose}
                        className="hover:bg-gray-50 cursor-pointer rounded border border-blue-300 bg-white px-4 py-2 text-[#C02626] hover:bg-slate-300"
                      >
                        Cancel
                      </button>
                      <button
                        onClick={handleAssign}
                        className={`rounded px-4 py-2 text-white ${
                          assignmentType === "Unassign"
                            ? "bg-red-600 hover:bg-red-700"
                            : "cursor-pointer rounded bg-[#4B789B] px-6 py-2 text-sm font-medium text-[#FFB547] hover:bg-[#3D6179]"
                        }`}
                      >
                        {assignmentType === "Unassign" ? "Unassign" : "Save"}
                      </button>
                    </div>
                  </div>
                </DialogComponent>

                <style>
                  {`
                  .casemanagement-grid .e-groupdroparea {
                    background-color: #003460!important;
                    color: white;
                }

                  .casemanagement-grid .e-groupcaption {
                    background-color: #deecf9;
                }
                  .casemanagement-grid .e-groupdroparea.e-drag {
                    border-color: #3b82f6;
                    background-color: white;
                  }

                  .casemanagement-grid .e-groupdroparea .e-grouped-header {
                    background-color: #e2e8f0;
                    border: 1px solid #cbd5e1;
                    border-radius: 4px;
                  }
                    .assign-center.e-dialog {
                    max-height: 1000px !important;
                    height: 500px !important;
                  }

                  .assign-center .e-footer-content {
                    background: white;
                    border-top: 1px solid #e5e7eb;
                    padding: 1rem;
                  }
                .icon-recovery-tracker {
                  filter: invert(100%) sepia(0%) saturate(0%) hue-rotate(93deg) brightness(103%) contrast(103%);
                }
                .group:hover .icon-recovery-tracker {
                  filter: invert(100%) sepia(0%) saturate(0%) hue-rotate(93deg) brightness(103%) contrast(103%);
                }

                .icon-assign {
                  filter: invert(100%) sepia(0%) saturate(0%) hue-rotate(93deg) brightness(103%) contrast(103%);
                }
                .group:hover .icon-assign {
                  filter: invert(100%) sepia(0%) saturate(0%) hue-rotate(93deg) brightness(103%) contrast(103%);
                }

                .icon-reassign {
                  filter: invert(100%) sepia(0%) saturate(0%) hue-rotate(93deg) brightness(103%) contrast(103%);
                }
                .group:hover .icon-reassign {
                  filter: invert(100%) sepia(0%) saturate(0%) hue-rotate(93deg) brightness(103%) contrast(103%);
                }

                .icon-access-account {
                  filter: invert(100%) sepia(0%) saturate(0%) hue-rotate(93deg) brightness(103%) contrast(103%);
                }
                .group:hover .icon-access-account {
                  filter: invert(100%) sepia(0%) saturate(0%) hue-rotate(93deg) brightness(103%) contrast(103%);
                }
                  .custom-grid-dialog .e-gridheader {
                    background-color: #F8F8F8 !important;
                    border-bottom: 1px solid #E0E0E0;
                  }

                  .custom-grid-dialog .e-headercell {
                    background-color: #F8F8F8 !important;
                    color: #242424 !important;
                    font-weight: 500 !important;
                    font-size: 14px !important;
                    border-right: none !important;
                  }

                  .custom-grid-dialog .e-headercelldiv {
                    display: flex !important;
                    align-items: center !important;
                    gap: 4px !important;
                  }

                  .custom-grid-dialog .e-icon-filter::before {
                    
                    font-size: 8px !important;
                    color: #242424 !important;
                  }
                `}
                </style>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default CaseManagementPartner;
